<template>
    <div id="bankTransferList" class="banktransfer-list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div v-if="customerId != undefined">
            <data-table-filter-config :moduleName="'bankTransferSubList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white">
                <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange" :moduleName="'bankTransferSubList'">
                </custom-pagination>

                <vue-good-table
                    ref="listbankTransferTable"
                    mode="remote"
                    title="Bank Transfer"
                    @on-page-change="onPageChange"
                    @on-selected-rows-change="selectionChanged"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    @on-row-click="expandthis"
                    :totalRows="totalRecords"
                    :columns="userColumns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: false,
                        position: 'bottom',
                        perPage: perPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
                    :select-options="{
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    }"
                    :search-options="{
                    enabled: false,
                    }">
                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'tag'">
                                <span v-fp-html="props.formattedRow[props.column.field]"></span>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                </vue-good-table>
                <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange">
                </custom-pagination>
            </div>
        </div>
        <div v-else id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Bank Reconciliation List</div>
                    <div class="btn-groups pull-right">
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a>
                        <button type="submit" id="createADjustmentReceiptBtn" class="btn btn-primary" v-on:click.prevent="adjustReceipt">
                            Adjustment
                        </button>
                        <button type="submit" id="createReceiptBtn" class="btn btn-primary" v-on:click.prevent="addReceipt">
                            <i class="fp-add"></i>Add Receipt
                        </button>
                        <router-link title="Back" v-if="$route.query.flag != undefined && $route.query.flag == 'gl'" class="btn btn-secondary" v-bind:to="{name: 'GeneralLedgerReport'}"><i class="fp-back"> </i>Back </router-link>
                        <router-link title="Back" v-if="$route.query.from != undefined && $route.query.from == 'dashboard'" class="btn btn-secondary" v-bind:to="{name: 'Dashboard'}"><i class="fp-back"> </i>Back </router-link>
                        </div>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content bank-tranfer-list">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div class="">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                    <button type="button" id="getBankRecords" v-on:click="getBankRecords('bank')" :class="'btn btn-secondary ' + bankActive"> Bank </button>
                                    <button type="button" id="getManualRecords" v-on:click="getBankRecords('manual')" :class="'btn btn-secondary ' + manualActive"> Manual </button>
                                </div>
                            </div>
                        </div>
                        <data-table-filter-config :moduleName="'bankTransferList'" @cancelSelection="cancelAll" :fromDashboard="$route.query.from" :allowSameFilter="'allow'" :routeSelId="routeSelId"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :moduleName="'bankTransferList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listbankTransferTable"
                                    mode="remote"
                                    title="Bank Transfer"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-row-click="expandthis"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'bottom',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">
                                     <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'tag'">
                                                <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                            </div>
                                             <div v-else-if="props.column.field == 'id'">
                                                <span :id="'row-id-'+props.row.id" v-fp-html="props.formattedRow[props.column.field]"></span>
                                            </div>
                                             <div v-else-if="props.column.field == 'action'">
                                                <router-link v-if="props.row.status == 'pending' && bankActive == ''" title="Edit Receipt" v-bind:key="'action' + key" class="fp-edit mr-3" v-bind:to="{name: 'ReceiptEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                      <button v-if="canRemoveRecords && bankActive == ''" id="deleteBankRecBtn" v-on:click.prevent="bankRecDelete" class="btn btn-danger">Delete</button>
                                      <button id="discardedButton" v-on:click.prevent="changeDiscarded('discard')" class="btn btn-primary">Discard</button>
                                      <button id="undodiscardedButton" v-on:click.prevent="changeDiscarded('undo')" class="btn btn-primary">Undo Discard</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange">
                                </custom-pagination>

                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
        <div class="modal fade invoice-modal" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Select File</h5>
                    </div>
                    <div class="modal-body">
                        <form id="importFile" class="addinspectionForm">
                            <div class="form-row import-file-upload">
                                <div class="col-sm-7">
                                    <label class="control-label require" for="name">File:</label>
                                    <input id="typeImage" type="file" @change="onFileChanged">
                                    <div class="field-error">{{importerror}}</div>
                                </div>
                            </div>
                            <div class="col-md-12 form-group">
                                <div class="custom-checkbox">
                                    <label class="checkbox-custom">  LockBox <input type="checkbox" v-model="lockbox" id="lockbox" name="lockbox" @click="checkIfClick($event,'lock')">
                                    <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="custom-checkbox">
                                    <label class="checkbox-custom">  Remote Online Deposit <input type="checkbox" v-model="rod" id="rod" name="rod" @click="checkIfClick($event,'rod')">
                                    <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="custom-checkbox">
                                    <label class="checkbox-custom">  ACH Upload <input type="checkbox" v-model="ach" id="ach" name="ach" @click="checkIfClick($event,'ach')">
                                    <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="col form-group" v-show="ach">
                                <label class="control-label require" for="Sequence">#Sequence:</label>
                                <v-select v-model="sequence" name="sequence"
                                        label="text" :filterable="false" :options="sequenceArr"
                                        @search="onSearchSequence"
                                        placeholder="Select Sequence" class="custom-ci-auto-search">
                                    <template slot="no-options">
                                        Search Sequence...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                        {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                        {{ option.text }}
                                        </div>
                                    </template>
                                </v-select>
                                <div class="field-error">{{ sequence_error_msg }}</div>
                            </div>
                            <template v-if="duplicateTransfer && duplicateTransfer.length > 0">
                                <label> These Bank Transfer Already Exist:</label>
                                <template v-for="(trans,perKey) in duplicateTransfer">
                                    <a :key="perKey" v-if="perKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="perKey">{{trans.reference_no}}</span>
                                </template>
                            </template>
                            <template v-if="disUrl != ''">
                                <label> Date format is not proper: &nbsp;<span v-fp-html="disUrl"></span></label>
                            </template>

                            <div class="bank-transferimport"></div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-tertiary" id="okbutton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                        <button class="btn btn-secondary" id="myButton" v-on:click="importTransfers()"> <i class="fp-import"> </i> Import</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal mapreceipt-modal" id="myBankModal" ref="myBankModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div :class="`loader${loaderClass}`" v-show="loadingModal">
                </div>

                <div class="modal-content adjustWidth" :style="'margin-top:'+rcTop+'px'">
                    <div class="modal-header">
                        Map Receipt

                        <button class="btn btn-tertiary pull-right" id="okbutton" v-on:click="resetAll()" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                    </div>

                    <div class="modal-body">
                        <div class="col col-md-4 form-group">
                            <label class="control-label">Transaction Type</label>
                            <v-select v-model="transaction_type" name="transaction_type" placeholder="Select Type."
                                    label="text" @input="onChangeTrType()"
                                    :options="transactionTypeArr" :disabled="trTypeDisable">
                            </v-select>
                        </div>
                        <form id="bankRecMapper" class="addinspectionForm additionClassTop" v-if="rowActivate">
                            <div class="misc-cash receiptBlock" style="font-size:0.9rem;">
                                <div class="form-row receipt-tabs" v-if="type != 'Adj'">
                                    <div class="col tab1 d-inline-block" v-if="!depositRecords">
                                        <input type="radio" id="rbsettlementacctp" class="findmatch mr-2 d-none" name="pay_type" @input="settlementAccount($event)" />
                                        <label class="ml-5" for="rbsettlementacctp"> Settled Amount <span class="active-tab"></span></label>
                                    </div>
                                    <div class="findmatchOption col tab2" v-show="!depositRecords">
                                        <input type="radio" id="rbfindMatch1" class="findmatch mr-2 d-none" name="pay_type" @input="checkFindMatch($event)" />
                                        <label for="rbfindMatch1"> Find Match <span class="active-tab"></span></label>
                                    </div>
                                    <div class="findmatchOption col tab2" v-if="!depositRecords">
                                        <input type="radio" id="rbfindgl" class="findmatch mr-2 d-none" name="pay_type" @input="checkFindGL($event)" />
                                        <label for="rbfindgl"> Find G/L  <span class="active-tab"></span></label>
                                    </div>
                                    <div class="findmatchOption col tab2" v-show="!depositRecords">
                                        <input type="radio" id="rbfindCustomMatch" class="findmatch mr-2 d-none" name="pay_type" @input="checkVoucher($event)" />
                                        <label for="rbfindCustomMatch"> Custom Match  <span class="active-tab"></span></label>
                                    </div>
                                </div>
                                <div v-if="type != 'Adj'">
                                    <template v-if="checkData && checkData.length > 0 && !onSettlementAccount && !findGLMatch && !partialAPMatch">
                                         <div class="form-row mt-5 mb-2">
                                            <div class="col">
                                                <table aria-describedby="table" width="300" class="account-table pull-right">
                                                    <tr>
                                                        <td>Payment Amount</td>
                                                        <td>{{payment_amount}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Applied Amount</td>
                                                        <td>{{amount_applied}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Remaining Amount</td>
                                                        <td>{{difference}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="btn-groups mt-2 mb-2" v-if="paymentIds && paymentIds.length > 0">
                                            <button type="submit" class="btn btn-primary mapData1 mb-2" v-on:click.prevent="mapRecords(selId,type)">Map</button>
                                        </div>
                                        <table aria-describedby="table" class="table table-sm table-bordered font-1 mt-2 mb-2">
                                            <th scope="col">&nbsp;</th>
                                            <th scope="col">Payment Number</th>
                                            <th>Vendor</th>
                                            <th>Payment Date</th>
                                            <th class="text-right">Amount</th>
                                            <th>Is Mapped</th>
                                            <th>Action</th>
                                            <tr v-for="(ch,ind) in checkData" :key="ind">
                                                <td><input type="checkbox" id="payment" class="paymentSelect"
                                                name="payment" :data-id="ch.id" @input="paymentSelected($event,ch.id,'payment',ch.payment_amount)"></td>
                                                <td>{{ch.payment_no}}</td>
                                                <td>{{ch.vendor}}</td>
                                                <td>{{ch.payment_date}}</td>
                                                <td class="text-right">{{ch.payment_amount}}</td>
                                                <td v-if="ch.status == 'closed'">Yes</td>
                                                <td v-else>No</td>
                                                <td v-if="ch.status != 'closed'">
                                                    <button type="submit" class="btn btn-primary mapData1 mb-2" v-on:click.prevent="paymentSelected($event,ch.id,'payment_map',ch.payment_amount)">Map</button>
                                                </td>
                                                <td v-else>-</td>
                                            </tr>
                                        </table>
                                    </template>
                                    <template v-else>
                                        <span class="mt-3 mb-3" v-if="!depositRecords && !onSettlementAccount && !findGLMatch && !partialAPMatch"> {{notFoundMsg}}</span>
                                    </template>
                                    <template v-if="onSettlementAccount && !depositRecords">
                                        <div class="form-row mt-5">
                                            <div class="col">
                                                <table aria-describedby="table" width="700" class="account-table">
                                                    <tr>
                                                        <td>A/c No.</td>
                                                        <td>{{account_no}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>A/c Name</td>
                                                        <td>{{account_name}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Type</td>
                                                        <td>{{type}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Amount</td>
                                                        <td>{{amount}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Date</td>
                                                        <td>{{date}}</td>
                                                    </tr>
                                                     <tr>
                                                        <td>Description</td>
                                                        <td>{{description}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="col">
                                                <div class="pull-right" v-if="!depositRecords">
                                                    <template v-show="alreadyMapped">
                                                        <div>
                                                            <doughnut-chart :chart-data="expchartData"></doughnut-chart>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="mappedPayments && mappedPayments.length > 0" class="mt-4">
                                            <strong class="font-bold d-block mb-2">Payment</strong>

                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <th>Vendor</th>
                                                <th>Payment Number</th>
                                                <th class="text-right">Payment Amount</th>
                                                <th>Payment Date</th>
                                                <th>Status</th>
                                                <th>Action</th>

                                            <tr v-for="(payrow, payindex) in mappedPayments" :key="payindex">
                                                <td>{{payrow.vendor}}</td>
                                                <td>{{payrow.payment_no}}</td>
                                                <td class="text-right">{{payrow.payment_amount}}</td>
                                                <td class="text-right">{{payrow.payment_date}}</td>
                                                <td v-if="payrow.is_cancelled == 'yes'">Cancelled</td>
                                                <td v-else>Mapped</td>
                                                <td>
                                                    <button type="button" class="btn btn-primary" :id="'cancelButton'+vouindex" v-if="payrow.is_cancelled == 'no'" @click="cancelAPTransaction($event,payrow.id,'payment')">Cancel</button>
                                                </td>
                                            </tr>
                                            </table>
                                        </div>

                                        <div v-if="mappedVoucher && mappedVoucher.length > 0" class="mt-4">
                                            <strong class="font-bold d-block mb-2">Voucher</strong>

                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <th>Vendor</th>
                                                <th>Voucher Number</th>
                                                <th>Invoice Number</th>
                                                <th>Payment Number</th>
                                                <th class="text-right">Payment Amount</th>
                                                <th>Status</th>
                                                <th>Action</th>

                                            <tr v-for="(vourow, vouindex) in mappedVoucher" :key="vouindex">
                                                <td>{{vourow.vendor}}</td>
                                                <td>{{vourow.voucher_number}}</td>
                                                <td>{{vourow.bill_number}}</td>
                                                <td>{{vourow.payment_no}}</td>
                                                <td class="text-right">{{vourow.amount}}</td>
                                                <td v-if="vourow.is_cancelled == 'yes'">Cancelled</td>
                                                <td v-else>Mapped</td>
                                                <td>
                                                    <button type="button" class="btn btn-primary" :id="'cancelButton'+vouindex" v-if="vourow.is_cancelled == 'no'" @click="cancelAPTransaction($event,vourow.id,'voucher')">Cancel</button>
                                                </td>
                                            </tr>
                                            </table>
                                        </div>

                                        <div v-if="mappedAL && mappedAL.length > 0" class="mt-4">
                                            <strong class="font-bold d-block mb-2">General Ledger</strong>

                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <th>GL Account</th>
                                                <th>Transaction Number</th>
                                                <th class="text-right">Payment Amount</th>
                                                <th>Status</th>
                                                <th>Action</th>

                                            <tr v-for="(alrow, alindex) in mappedAL" :key="alindex">
                                                <td>{{alrow.gl_account}}</td>
                                                <td>{{alrow.transaction_number}}</td>
                                                <td class="text-right">{{alrow.amount}}</td>
                                                <td v-if="alrow.is_cancelled == 'yes'">Cancelled</td>
                                                <td v-else>Mapped</td>
                                                <td>
                                                    <button type="button" class="btn btn-primary" :id="'cancelButton'+alindex" v-if="alrow.is_cancelled == 'no'" @click="cancelAPTransaction($event,alrow.id,'al')">Cancel</button>
                                                </td>
                                            </tr>
                                            </table>
                                        </div>
                                    </template>
                                    <!-- <div v-if="partialAPMatch">
                                        <div class="form-row mt-5 mb-2">
                                            <div class="col">
                                                <table aria-describedby="table" width="300" class="account-table pull-right">
                                                    <tr>
                                                        <td>Payment Amount</td>
                                                        <td>{{payment_amount}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Applied Amount</td>
                                                        <td>{{amount_applied}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Remaining Amount</td>
                                                        <td>{{difference}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col form-group">
                                                <label class="control-label">Search Vendor</label>
                                                <div class="border-1">
                                                    <div class="form-row">
                                                        <div class="col-md-5">
                                                            <label class="control-label" for="customer_id">Vendor:</label>
                                                            <v-select v-model="vendor_id" name="vendor_id" id="vendor_id" label="text" :filterable="false" :options="vendorArr" @search="onSearchVendor" placeholder="Select Vendor" @change="getVouchers('')" class='custom-ci-auto-search'>
                                                                <template slot="no-options">
                                                                    Search Vendor...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                            </template>
                                                            </v-select>
                                                            <div class="field-error">{{ vendor_error_msg }}</div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label class="control-label" for="voucher_ids">Voucher Number:</label>
                                                            <v-select v-model="voucher_ids" name="voucher_ids" multiple id="voucher_ids" label="text" :filterable="false" :options="voucherArr" @search="onSearchVoucher" placeholder="Select Voucher" class='custom-ci-auto-search invoice-multiple'>
                                                                <template slot="no-options">
                                                                    Search Voucher...
                                                                </template>
                                                                <template slot="option" multiple slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" multiple slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                            </v-select>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <button type="submit" v-on:click.prevent="getVouchers('voucher')" class="btn btn-primary mt-4">
                                                                <i class="fp-add"></i> Add
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="mt-2">
                                                        <div class="purchase-order-create-main table-responsive-sm" v-if="voucherrows && voucherrows.length > 0">
                                                            <div v-if="voucherIds && voucherIds.length > 0" class="selection-info-row">
                                                                <button type="submit" v-on:click.prevent="grossVoucher('','','multiple')" class="btn btn-primary">Map</button>
                                                            </div>
                                                            <vue-good-table
                                                                ref="listVoucherTable"
                                                                title="Vouchers"
                                                                :columns="vouchercolumns"
                                                                :rows="voucherrows"
                                                                max-height="600px"
                                                                :totalRows="voucherTotalRec"
                                                                @on-selected-rows-change="clickAPRows"
                                                                :pagination-options="{
                                                                    enabled: true,
                                                                    position:'top',
                                                                    mode: 'records',
                                                                    perPage: 100,
                                                                    perPageDropdown:[50,100],
                                                                    dropdownAllowAll: false,
                                                                }"
                                                                :search-options="{
                                                                    enabled: false,
                                                                    placeholder: 'Search Asset',
                                                                }"
                                                                :select-options="{
                                                                    enabled: true,
                                                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                                                    selectionInfoClass: 'custom-class',
                                                                    selectionText: 'rows selected',
                                                                    clearSelectionText: 'clear',
                                                                }"
                                                                :sort-options="{
                                                                    enabled: true,
                                                                }">
                                                                <div slot="emptystate">
                                                                    No Data Found.
                                                                </div>
                                                                <template slot="table-row" slot-scope="props" v-for="(row1,key) in voucherrows">
                                                                    <div :key="key">
                                                                        <template v-if="props.column.field == 'action'">
                                                                                <a href="javascript:void(0)" v-on:click.prevent="grossVoucher(props.row.bill_id,props.row.total,'one')" class="color-blue underline" id="fullAPMap">
                                                                                    Full
                                                                                </a>
                                                                        </template>
                                                                        <template v-else>
                                                                            {{props.formattedRow[props.column.field]}}
                                                                        </template>
                                                                    </div>
                                                                </template>

                                                            </vue-good-table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                                    <div v-if="partialAPMatch">
                                        <div class="form-row mt-5 mb-2">
                                            <div class="col">
                                                <table aria-describedby="table" width="300" class="account-table pull-right">
                                                    <tr>
                                                        <td>Payment Amount</td>
                                                        <td>{{payment_amount}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Applied Amount</td>
                                                        <td>{{amount_applied}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Remaining Amount</td>
                                                        <td>{{difference}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col form-group">
                                                <label class="control-label">Search Vendor</label>
                                                <div class="border-1">
                                                    <div class="form-row">
                                                        <div class="col-md-5">
                                                            <label class="control-label" for="customer_id">Vendor:</label>
                                                            <v-select v-model="vendor_id" name="vendor_id" id="vendor_id" label="text" :filterable="false" :options="vendorArr" @search="onSearchVendor" placeholder="Select Vendor" @change="getVouchers('payment')" class='custom-ci-auto-search'>
                                                                <template slot="no-options">
                                                                    Search Vendor...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                            </template>
                                                            </v-select>
                                                            <div class="field-error">{{ vendor_error_msg }}</div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label class="control-label" for="ap_payments">Payment Number:</label>
                                                            <v-select v-model="ap_payments" name="ap_payments" multiple id="ap_payments" label="text" :filterable="false" :options="paymentArr" @search="onSearchPayment" placeholder="Select Payment" class='custom-ci-auto-search invoice-multiple'>
                                                                <template slot="no-options">
                                                                    Search Payment...
                                                                </template>
                                                                <template slot="option" multiple slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" multiple slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                            </v-select>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <button type="submit" v-on:click.prevent="getVouchers('payment')" class="btn btn-primary mt-4">
                                                                <i class="fp-add"></i> Add
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="mt-2">
                                                        <div class="purchase-order-create-main table-responsive-sm" v-if="paymentRows && paymentRows.length > 0">
                                                            <div v-if="apPaymentIds && apPaymentIds.length > 0" class="selection-info-row">
                                                                <button type="submit" v-on:click.prevent="grossVoucher('','','multiple','payment')" class="btn btn-primary">Map</button>
                                                            </div>
                                                            <vue-good-table
                                                                ref="listPaymentTable"
                                                                title="Vouchers"
                                                                :columns="paymentColumns"
                                                                :rows="paymentRows"
                                                                max-height="600px"
                                                                :totalRows="voucherTotalRec"
                                                                @on-selected-rows-change="clickAPPaymentRows"
                                                                :pagination-options="{
                                                                    enabled: true,
                                                                    position:'top',
                                                                    mode: 'records',
                                                                    perPage: 100,
                                                                    perPageDropdown:[50,100],
                                                                    dropdownAllowAll: false,
                                                                }"
                                                                :search-options="{
                                                                    enabled: false,
                                                                    placeholder: 'Search Asset',
                                                                }"
                                                                :select-options="{
                                                                    enabled: true,
                                                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                                                    selectionInfoClass: 'custom-class',
                                                                    selectionText: 'rows selected',
                                                                    clearSelectionText: 'clear',
                                                                }"
                                                                :sort-options="{
                                                                    enabled: true,
                                                                }">
                                                                <div slot="emptystate">
                                                                    No Data Found.
                                                                </div>
                                                                <template slot="table-row" slot-scope="props" v-for="(row1,key) in paymentRows">
                                                                    <div :key="key">
                                                                        <template v-if="props.column.field == 'action'">
                                                                                <a href="javascript:void(0)" v-on:click.prevent="grossVoucher(props.row.payment_id,props.row.total,'one','payment')" class="color-blue underline" id="fullAPMap">
                                                                                    Full
                                                                                </a>
                                                                        </template>
                                                                        <template v-else>
                                                                            {{props.formattedRow[props.column.field]}}
                                                                        </template>
                                                                    </div>
                                                                </template>

                                                            </vue-good-table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="findGLMatch">
                                         <div class="form-row mt-5 mb-2">
                                            <div class="col">
                                                <table aria-describedby="table" width="300" class="account-table pull-right">
                                                    <tr>
                                                        <td>Payment Amount</td>
                                                        <td>{{payment_amount}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Applied Amount</td>
                                                        <td>{{amount_applied}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Remaining Amount</td>
                                                        <td>{{difference}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col form-group">
                                                <label class="control-label">Search JV Number</label>
                                                <div class="border-1">
                                                    <div class="form-row">
                                                        <div class="col-md-5">
                                                            <label class="control-label" for="customer_id">JV Number:</label>
                                                            <v-select v-model="al_id" name="al_id" id="al_id" label="text" :filterable="false" :options="jvArr" @search="onSearchAL" placeholder="Select Journal Voucher" @input="fetchGLWithSameAmount('al_search')" class='custom-ci-auto-search'>
                                                                <template slot="no-options">
                                                                    Search JV...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                            </template>
                                                            </v-select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p>&nbsp;</p>
                                        <template v-if="glMapData && glMapData.length">
                                        <div class="btn-groups mt-2 mb-2">
                                            <button v-if="selectedGLArr && selectedGLArr.length > 0" type="submit" class="btn btn-primary mapData" v-on:click.prevent="grossGLMapping(selectedGLArr,'','multiple')">Map</button>
                                        </div>
                                            <template>
                                                <table aria-describedby="table" class="table table-sm table-bordered font-1 cover">
                                                    <th>&nbsp;</th>
                                                    <th>GL Number</th>
                                                    <th>Transaction Number</th>
                                                    <th>JV Number</th>
                                                    <th>Description</th>
                                                    <th>Amount</th>
                                                    <th>Payment Date</th>
                                                    <th style="width:20px;">Action</th>
                                                <tr v-for="(glm,glndc) in glMapData" :key="glndc">
                                                    <td><input type="checkbox" id="payment" class="paymentSelect"
                                                    name="payment" :data-id="glm.id" @input="selectAccountLedger($event,glm.id,glm.payment_amount)"></td>
                                                    <td v-fp-html="glm.gl_account"></td>
                                                    <td>{{glm.transaction_number}}</td>
                                                    <td>{{glm.jv_number}}</td>
                                                    <td>{{glm.header_description}}</td>
                                                    <td>{{glm.payment_amount}}</td>
                                                    <td>{{glm.payment_date}}</td>
                                                    <td>
                                                        <template v-if="glm.is_settled == 'no'">
                                                            <a href="javascript:void(0)" v-on:click.prevent="grossGLMapping(glm.id,glm.payment_amount,'one')" class="color-blue underline" id="fullGlMap">
                                                                Full
                                                            </a>
                                                            <!-- <a  href="javascript:void(0)" v-if="inv.current_open_inv_amount > 0 && showFullAndCustom" v-on:click.prevent="spInvoice(inv.id,inv.current_open_inv_amount)" class="color-blue underline" id="upClick">
                                                                Partial
                                                            </a> -->
                                                            <span class="close-row" v-if="glm.payment_amount == 0"> - </span>
                                                        </template>
                                                        <template v-else>
                                                            <span class="close-row"> - </span>
                                                        </template>
                                                    </td>
                                                </tr>
                                                </table>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <span class="mt-3 mb-3">{{notFoundMsg}}</span>
                                        </template>
                                    </div>

                                </div>
                                <div v-show="depositRecords">
                                    <div class="form-row receipt-tabs">
                                    <div class="col tab1 d-inline-block">
                                        <input type="radio" id="rbsettlementacct" class="findmatch mr-2 d-none" name="map_type" @input="settlementAccount($event)" checked />
                                        <label class="ml-5" for="rbsettlementacct"> Settled Amount <span class="active-tab"></span></label>
                                    </div>
                                    <div class="col tab2 d-inline-block text-center" v-if="type != 'Adj'">
                                        <input type="radio" id="rbfindMatch" class="findmatch mr-2 d-none" name="map_type" @input="checkFindMatch($event)" />
                                        <label for="rbfindMatch"> Find Match <span class="active-tab"></span></label>
                                    </div>
                                    <div class="col tab3 d-inline-block text-center" v-if="type != 'Adj'">
                                        <input type="radio" id="rbArfindgl" class="findmatch mr-2 d-none" name="map_type" @input="checkARFindGL($event)" />
                                        <label for="rbArfindgl"> Find G/L  <span class="active-tab"></span></label>
                                    </div>
                                    <div class="col tab4 d-inline-block text-center">
                                        <input type="radio" id="rbpartialMatch" class="findmatch mr-2 d-none" name="map_type" @input="checkPartialMapping($event)" />
                                        <label for="rbpartialMatch"> Custom Match <span class="active-tab"></span></label>
                                    </div>
                                    <div class="col tab5 d-inline-block text-center" v-if="type != 'Adj'">
                                        <input type="radio" id="rbsecurityDeposit" class="findmatch mr-2 d-none" name="map_type" @input="creditDeposit($event)" /><label for="rbsecurityDeposit"><span class="active-tab"></span> Security Deposit</label>
                                    </div>
                                  
                                    <div class="col tab6 d-inline-block text-center" v-if="type != 'Adj'">
                                        <input type="radio" id="rbaccountFund" class="findmatch mr-2 d-none" name="map_type" @input="onAccountApp($event)" />
                                        <label for="rbaccountFund"> On Account Fund <span class="active-tab"></span></label>
                                    </div>
                                   
                                    <div class="col tab7 d-inline-block text-right" v-if="type != 'Adj'">
                                        <input type="radio" id="rbdirectentry" class="findmatch mr-2 d-none" name="map_type" @input="cashFlow($event)" />
                                        <label class="mr-5" for="rbdirectentry"> Direct GL Entry <span class="active-tab"></span></label>
                                    </div>
                                    </div>

                                    <template v-if="invData && invData.length">
                                        <div class="btn-groups mt-2 mb-2">
                                            <button v-if="invoiceIds && invoiceIds.length > 0" type="submit" class="btn btn-primary mapData" v-on:click.prevent="mapRecords(selId,type)">Map</button>
                                        </div>
                                        <template v-for="(inc,indc) in invData">
                                            <span :key="indc">{{inc['cust_name']}}</span>
                                            <table aria-describedby="table" class="table table-sm table-bordered font-1 cover" :key="indc">
                                                <th>&nbsp;</th>
                                                <th>Invoice Number</th>
                                                <th>Amount</th>
                                                <th>Open Amount</th>
                                                <th style="width:20px;">Action</th>

                                            <tr v-for="(inv,index) in invData[indc]['inv']" :key="index">
                                                <td><input type="checkbox" id="payment" class="paymentSelect"
                                                name="payment" :data-id="inv.id" @input="paymentSelected($event,inv.id,'deposit',inv.current_open_inv_amount)"></td>
                                                <td v-fp-html="inv.invoice_number"></td>
                                                <td>{{inv.amount}}</td>
                                                <td>{{inv.current_open_inv_amount}}</td>
                                                <td>
                                                    <template v-if="inv.current_open_inv_amount == difference">
                                                        <a href="javascript:void(0)" v-if="inv.current_open_inv_amount > 0 && showFullAndCustom" v-on:click.prevent="grossInvoice(inv.id,inv.current_open_inv_amount,'one')" class="color-blue underline">
                                                            Full
                                                        </a>
                                                        <a  href="javascript:void(0)" v-if="inv.current_open_inv_amount > 0 && showFullAndCustom" v-on:click.prevent="spInvoice($event,inv.id,inv.current_open_inv_amount)" class="color-blue underline" id="upClick">
                                                            Partial
                                                        </a>
                                                        <span class="close-row" v-if="inv.current_open_inv_amount == 0"> - </span>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> - </span>
                                                    </template>
                                                </td>

                                            </tr>
                                            </table>
                                        </template>

                                    </template>
                                    <template v-else>
                                        <span class="mt-3 mb-3" v-show="(depositRecords) && disError"> {{notFoundMsg}}</span>
                                    </template>
                                    <template v-if="creditrows && creditrows.length > 0 && onSecurityDeposit">
                                        <div class="custom-checkbox mt-5">
                                            <label class="checkbox-custom">With Asset
                                            <input type="checkbox" v-model="isUnit" id="isUnit"
                                            name="isUnit" v-on:click="isUnitSelect($event)">
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </template>
                                    <template v-if="onSettlementAccount">
                                        <div class="form-row mt-5">
                                            <div class="col">
                                                <table aria-describedby="table" width="700" class="account-table">
                                                    <tr>
                                                        <td>A/c No.</td>
                                                        <td>{{account_no}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>A/c Name</td>
                                                        <td>{{account_name}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Type</td>
                                                        <td>{{type}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Amount</td>
                                                        <td>{{amount}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Date</td>
                                                        <td>{{date}}</td>
                                                    </tr>
                                                     <tr>
                                                        <td>Description</td>
                                                        <td>{{description}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="col">
                                                <div class="pull-right" v-if="depositRecords">
                                                    <template v-show="alreadyMapped">
                                                        <div>
                                                            <doughnut-chart :chart-data="expchartData"></doughnut-chart>
                                                        </div>
                                                    </template>
                                                   
                                                    <p>&nbsp;</p>
                                                </div>
                                            </div>
                                        </div>
                                       
                                        <div v-if="allMapped && allMapped.length > 0" class="mt-4">

                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <th>App Type</th>
                                                <th>DOC/ACCT</th>
                                                <th>Customer</th>
                                                <th class="text-right">Applied Amount</th>
                                                <th>Status</th>
                                                <th>Action</th>

                                            <tr v-for="(mprow, mpindex) in allMapped" :key="mpindex">
                                                <td>{{mprow.app_type}}</td>
                                                <td v-fp-html="mprow.document_number"></td>
                                                <td>{{mprow.customer}}</td>
                                                <td class="text-right">{{mprow.applied_amount}}</td>
                                                <td v-if="mprow.is_cancelled == 'yes'">Cancelled</td>
                                                <td v-else>{{mprow.type}}</td>
                                                <td>
                                                    <button type="button" class="btn btn-danger" :id="'cancelButton'+mpindex" v-if="mprow.type == 'Applied' && mprow.app_type == 'Document' && mprow.is_cancelled == 'no'" @click="clickRows($event,mprow.mapper_id,mprow.invoice_id,mprow.current_open_inv_amount,mprow.invoice_amount,'settle_screen')">Cancel</button>
                                                </td>
                                            </tr>
                                            </table>
                                        </div>
                                        <div v-if="mappedAL && mappedAL.length > 0" class="mt-4">
                                            <strong class="font-bold d-block mb-2">General Ledger</strong>

                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <th>GL Account</th>
                                                <th>Transaction Number</th>
                                                <th class="text-right">Payment Amount</th>
                                                <th>Status</th>
                                                <th>Action</th>

                                            <tr v-for="(alrow, alindex) in mappedAL" :key="alindex">
                                                <td>{{alrow.gl_account}}</td>
                                                <td>{{alrow.transaction_number}}</td>
                                                <td class="text-right">{{alrow.amount}}</td>
                                                <td v-if="alrow.is_cancelled == 'yes'">Cancelled</td>
                                                <td v-else>Mapped</td>
                                                <td>
                                                    <button type="button" class="btn btn-primary" :id="'cancelButton'+alindex" v-if="alrow.is_cancelled == 'no'" @click="cancelAPTransaction($event,alrow.id,'al')">Cancel</button>
                                                </td>
                                            </tr>
                                            </table>
                                        </div>
                                        <div v-if="bdglView && bdglView.length > 0" class="mt-4">
                                            <strong class="font-bold d-block mb-2">BD Write Off</strong>

                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <th>GL Account</th>
                                                <th>Invoice</th>
                                                <th>Customer</th>
                                                <th class="text-right">Amount</th>

                                            <tr v-for="(bd, bdindex) in bdglView" :key="bdindex">
                                                <td>{{bd.gl}}</td>
                                                <td v-fp-html="bd.document_number"></td>
                                                <td>{{bd.customer}}</td>
                                                <td class="text-right">{{bd.amount}}</td>
                                            </tr>
                                            </table>
                                        </div>

                                        <div v-if="refundView && refundView.length > 0" class="mt-4">
                                            <strong class="font-bold d-block mb-2">Refund</strong>

                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <th>GL Account</th>
                                                <th>Invoice</th>
                                                <th>Customer</th>
                                                <th class="text-right">Amount</th>

                                            <tr v-for="(rf, rfindex) in refundView" :key="rfindex">
                                                <td>{{rf.gl}}</td>
                                                <td v-fp-html="rf.document_number"></td>
                                                <td>{{rf.customer}}</td>
                                                <td class="text-right">{{rf.amount}}</td>
                                            </tr>
                                            </table>
                                        </div>


                                    </template>
                                    <div class="invoiceFoundMsg">

                                        <div v-if="accrows && accrows.length > 0 && onAccount" class="mt-5">
                                            <div class="form-row" v-for="(acrow, acindex) in accrows" :key="acindex">
                                                    <div class="col form-group">
                                                        <label class="control-label require" v-show="acindex == 0">Customer</label>
                                                        <v-select v-model="acrow.acc_customer_id" name="acc_customer_id" id="acc_customer_id" label="text" :filterable="false" :options="customerArr" @search="onSearchCustomer" placeholder="Select Customer" class='custom-ci-auto-search'>
                                                        <template slot="no-options">
                                                            Search Customer...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{ acrow.customer_error_msg }}</div>
                                                    </div>
                                                    <div class="col form-group">
                                                        <label class="control-label" v-show="acindex == 0">Description</label>
                                                        <input type="text" placeholder="Enter Description" v-model="acrow.description" name="description" id="description" class="form-control">
                                                    </div>
                                                    <div class="col form-group">
                                                        <label class="control-label require" v-show="acindex == 0">Amount</label>
                                                        <input type="text" placeholder="Enter Amount" v-model="acrow.amount" name="amount" id="amount" class="form-control text-right" @keypress="isAmountCheck($event)" @blur="setAmount(acindex,'on_account')">
                                                        <div class="field-error">{{acrow.amount_error_msg}}</div>
                                                    </div>
                                                     <div class="col-md-1 form-group text-center">
                                                        <label class="control-label require" v-show="acindex == 0">Action</label>
                                                        <template v-if="!acrow.is_cancelled || acrow.is_cancelled == 'no'">
                                                            <a class="btn btn-primary" href="javascript:void(0)" v-on:click.prevent="removeElement(acindex,'on_account');">Reverse <!--<i class="fp-remove"></i> -->
                                                                </a>
                                                        </template>
                                                        
                                                    </div>
                                            </div>
                                            <div class="btn-groups mb-2">
                                                <button type="submit" v-on:click.prevent="addRow('on_account')" class="btn btn-primary">
                                                    <i class="fp-add"></i> Add Line Item
                                                </button>
                                            </div>

                                        </div>
                                        <div v-if="cashrows && cashrows.length > 0 && onCash" class="mt-5">
                                            <div class="form-row" v-for="(crow, cindex) in cashrows" :key="cindex">
                                                <div class="col-md-3 form-group">
                                                    <label class="control-label require" v-show="cindex == 0">Account</label>
                                                    <v-select v-model="crow.gl_account_id" name="gl_account_id" id="gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                        <template slot="no-options">
                                                            Search GL Account...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{crow.account_error_msg}}</div>
                                                </div>
                                                <div class="col-md-4 form-group">
                                                    <label class="control-label" v-show="cindex == 0">Description</label>
                                                    <input type="text" placeholder="Enter Description" v-model="crow.description" name="description" id="description" class="form-control">
                                                </div>
                                                <div class="col-md-2 form-group">
                                                    <label class="control-label" v-show="cindex == 0">Tax</label>
                                                    <input type="text" placeholder="Enter Tax" v-model="crow.tax" name="tax" id="tax" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                </div>
                                                <div class="col-md-2 form-group">
                                                    <label class="control-label require" v-show="cindex == 0">Amount</label>
                                                    <input type="text" placeholder="Enter Amount" v-model="crow.amount" name="amount" id="amount" class="form-control text-right" @blur="setAmount(cindex,'on_cash')">
                                                    <div class="field-error">{{crow.amount_error_msg}}</div>
                                                </div>
                                                <div class="col-md-1 form-group text-center">
                                                    <label class="control-label" v-show="cindex == 0">Action</label>
                                                    <template v-if="!crow.is_cancelled || crow.is_cancelled == 'no'">
                                                        <a class="btn btn-primary" href="javascript:void(0)" v-on:click.prevent="removeElement(cindex,'on_cash');">Reverse <!--<i class="fp-remove"></i> -->
                                                            </a>
                                                    </template>
                                                </div>
                                            </div>

                                            <div class="btn-groups mb-2">
                                                <button type="submit" v-on:click.prevent="addRow('on_cash')" class="btn btn-primary">
                                                    <i class="fp-add"></i> Add Line Item
                                                </button>
                                            </div>
                                        </div>
                                        <div v-if="creditrows && creditrows.length > 0 && onSecurityDeposit">
                                            <div v-for="(drow, dindex) in creditrows" :key="dindex" class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require" v-show="dindex == 0">GL Account</label>
                                                    <input type="text" id="name" name="name" class="form-control" v-model="drow.gl_account_id.text" disabled>
                                                </div>
                                                <div class="col form-group">
                                                    <label class="control-label require" v-show="dindex == 0">Customer</label>
                                                    <v-select v-model="drow.customer_id" name="credit_customer_id" id="credit_customer_id" label="text" :filterable="false" :options="customerArr" @search="onSearchCustomer" placeholder="Select Customer" class='custom-ci-auto-search'>
                                                        <template slot="no-options">
                                                            Search Customer...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{ drow.customer_error_msg }}</div>
                                                </div>
                                                <div class="col form-group" v-if="isUnit">
                                                    <label class="control-label" v-show="dindex == 0">Asset</label>
                                                    <v-select v-model="drow.vehicle_id" name="vehicle_id" id="vehicle_id" label="text" :filterable="false" :options="vehicleArr" @search="onSearchVehicle" placeholder="Select Asset" class='custom-ci-auto-search'>
                                                        <template slot="no-options">
                                                            Search Asset...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                </div>
                                                <div class="col form-group" v-if="!isUnit">
                                                    <label class="control-label require" v-show="dindex == 0">Description</label>
                                                    <input type="text" placeholder="Enter Description" v-model="drow.description" name="description" id="description" class="form-control">
                                                    <div class="field-error">{{drow.description_error_msg}}</div>
                                                </div>
                                                <div class="col form-group">
                                                    <label class="control-label require" v-show="dindex == 0">Amount</label>
                                                    <input type="text" placeholder="Enter Amount" v-model="drow.amount" name="amount" id="amount" class="form-control text-right" @keypress="isAmountCheck($event)" @blur="setAmount(dindex,'on_deposit')">
                                                    <div class="field-error">{{drow.amount_error_msg}}</div>
                                                </div>
                                                <div class="col-md-1 form-group text-center">
                                                    <label class="control-label" v-show="dindex == 0">Action</label>
                                                    <template v-if="!drow.is_cancelled || drow.is_cancelled == 'no'">
                                                        <a class="btn btn-primary" href="javascript:void(0)" v-on:click.prevent="removeElement(dindex,'security');">Reverse  <!--  <i class="fp-remove"></i> -->
                                                            </a>
                                                    </template>
                                                </div>
                                            </div>
                                            <div class="btn-groups mb-2">
                                                <button type="submit" v-on:click.prevent="addRow('security')" class="btn btn-primary">
                                                    <i class="fp-add"></i> Add Line Item
                                                </button>
                                            </div>

                                            <div class="form-row row-cols-md-2 row-cols-1 ach-payment-section">
                                                <div class="col form-group verification-section-main">
                                                <label class="control-label" for="documents">Documents (.jpg, .jpeg, .png and .pdf files are allowed)</label>
                                                <div id="app2">
                                                    <vue-dropzone
                                                        id="selfInsuranceDocs"
                                                        :options="dropzoneOptions"
                                                        :destroyDropzone=false
                                                        ref="depositDropzone"
                                                        :headers="dropzoneOptions.headers"
                                                        @vdropzone-complete="afterComplete"
                                                        @vdropzone-success="storeDocument"
                                                        @vdropzone-duplicate-file="duplicateDocument"
                                                        @vdropzone-error="errorDocument"
                                                        @vdropzone-removed-file="removedSelectedFile"
                                                        >
                                                    </vue-dropzone>
                                                </div>
                                                    <div class="field-error">{{doc_error_msg}}</div>
                                                       <div class="col form-group"  v-if="dropZonePreviewFiles.length > 0">
                                                            <div class="policy-attachment attachment-list-box">
                                                            <label class="control-label" for="attachments">Attachments</label>
                                                            <template  v-for="(uFile,fKey) in dropZonePreviewFiles">
                                                                <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                                                    <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                                    <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                                                                    <i v-if="uFile.extension == 'jpg' ||  uFile.extension == 'png' ||  uFile.extension == 'jpeg' " class="fp-image"></i>
                                                                    <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.extension)" v-bind:key="'fileName'+fKey" >
                                                                        {{ uFile['display_name'] }}
                                                                    </a>
                                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                                    <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="removeFileFromServer(uFile['path'],'server',fKey);">
                                                                        <i class="fp-close"></i>
                                                                    </button>
                                                                </div>

                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="partialMatch">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label">Search Customer</label>
                                                    <div class="border-1">
                                                        <div class="form-row">
                                                            <div class="col-md-5">
                                                                <label class="control-label" for="customer_id">Customer:</label>
                                                                <v-select v-model="customer_id" name="customer_id" id="customer_id" label="text" :filterable="false" :options="customerArr" @search="onSearchCustomer" placeholder="Select Customer" @change="getInvoices('')" class='custom-ci-auto-search'>
                                                                    <template slot="no-options">
                                                                        Search Customer...
                                                                    </template>
                                                                    <template slot="option" slot-scope="option">
                                                                        <div class="d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                    <template slot="selected-option" slot-scope="option">
                                                                        <div class="selected d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                </template>
                                                                </v-select>
                                                                <div class="field-error">{{ customer_error_msg }}</div>
                                                            </div>
                                                            <div class="col-md-1" v-if="discountId > 0">
                                                                <label class="control-label" for="customer_id" style="width:100%;">&nbsp;</label>
                                                                <a href="javascript:void(0)" style="color:blue;" v-on:click="viewDiscount">View Discount</a>
                                                            </div>
                                                            <div class="col-md-5">
                                                                <label class="control-label" for="invoice_id">Invoice Number:</label>
                                                                <v-select v-model="invoice_ids" name="invoice_id" multiple id="invoice_id" label="text" :filterable="false" :options="invoiceArr" @search="onSearchInvoice" placeholder="Select Invoice" class='custom-ci-auto-search invoice-multiple'>
                                                                    <template slot="no-options">
                                                                        Search Invoice...
                                                                    </template>
                                                                    <template slot="option" multiple slot-scope="option">
                                                                        <div class="d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                    <template slot="selected-option" multiple slot-scope="option">
                                                                        <div class="selected d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                </v-select>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <button type="submit" v-on:click.prevent="getInvoices('invoice')" class="btn btn-primary mt-4">
                                                                    <i class="fp-add"></i> Add
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="mt-2">
                                                            <div class="purchase-order-create-main table-responsive-sm" v-if="invrows && invrows.length > 0">
                                                                <div v-if="invoiceIds && invoiceIds.length > 0" class="selection-info-row">
                                                                    <button type="submit" v-on:click.prevent="cancelReceiptPayment('deposit')" class="btn btn-danger"><strong>X</strong> &nbsp;&nbsp; Cancel</button>
                                                                    <button type="submit" v-if="!returnedTrans" v-on:click.prevent="grossInvoice('','','multiple')" class="btn btn-primary">Map</button>

                                                                </div>
                                                                <table aria-describedby="table" class="table table-sm table-bordered font-1 cover" id="scroll-to-bottom">
                                                                    <thead>
                                                                        <tr class="table-primary">
                                                                            <th scope="col" style="width:10px;"></th>
                                                                            <th scope="col" style="width:200px;">Customer</th>
                                                                            <th scope="col">Invoice Number</th>
                                                                            <th scope="col">Original Amount</th>
                                                                            <th scope="col">Open Amount</th>
                                                                            <th scope="col">Discounted Amount</th>
                                                                            <th scope="col" style="width:20px;">Status</th>
                                                                            <th scope="col" style="width:20px;">Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(invrow, index) in invrows" :key="index">
                                                                            <td>
                                                                                <input type="checkbox" :id="'cancelCheckbox'+index" @input="clickRows($event,invrow.mapper_id,invrow.invoice_id,invrow.current_open_inv_amount,invrow.invoice_amount,'custom')"/>
                                                                            </td>
                                                                            <td>
                                                                                {{invrow.customer_number}}
                                                                            </td>
                                                                            <td v-fp-html="invrow.invoice_number">
                                                                            </td>
                                                                            <td v-if="invrow.invoice_amount" class="text-right">
                                                                                ${{invrow.invoice_amount.toFixed(2)}}
                                                                            </td>
                                                                            <td v-else class="text-right">$0.00</td>
                                                                            <td v-if="invrow.current_open_inv_amount" class="text-right">
                                                                                ${{invrow.current_open_inv_amount.toFixed(2)}}
                                                                            </td>
                                                                            <td v-else class="text-right">$0.00</td>
                                                                            <td v-if="invrow.discounted_amount && invrow.discounted_amount != '-'" class="text-right">
                                                                                ${{invrow.discounted_amount.toFixed(2)}}
                                                                            </td>
                                                                            <td v-else class="text-right">
                                                                                -
                                                                            </td>
                                                                            <td>
                                                                                <span v-if="invrow.current_open_inv_amount.toFixed(2) == invrow.invoice_amount.toFixed(2)">
                                                                                    Un applied
                                                                                </span>
                                                                                <span v-else>
                                                                                    Applied
                                                                                </span>
                                                                            </td>
                                                                            <td>
                                                                                <template v-if="invrows.length > 0">
                                                                                    <a href="javascript:void(0)" v-if="((invrow.current_open_inv_amount > 0 || invrow.current_open_inv_amount.toFixed(2) == invrow.invoice_amount.toFixed(2)) && showFullAndCustom) || returnedTrans" v-on:click.prevent="grossInvoice(invrow.invoice_id,invrow.current_open_inv_amount,'one')" class="color-blue underline">
                                                                                        Full
                                                                                    </a>
                                                                                    <a  href="javascript:void(0)" v-if="showFullAndCustom" v-on:click.prevent="spInvoice($event,invrow.invoice_id,invrow.current_open_inv_amount)" class="color-blue underline" id="upClick">
                                                                                        Partial
                                                                                    </a>
                                                                                    <span class="close-row" v-if="invrow.current_open_inv_amount == 0"> - </span>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <span class="close-row"> - </span>
                                                                                </template>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <template v-if="specificInvoice">
                                            <div class="form-row">
                                                <div class="col-md-7">
                                                    <div class="specific-calc">
                                                        <div class="font-1 font-bold">Specific Amount Calculation</div>
                                                        <div class="specific-calc-wrapper">
                                                        <input type="hidden" class="form-control" v-model="spc_invoice_id"/>
                                                        <div class="form-row">
                                                            <div class="col-sm-6 form-group">
                                                                <label class="control-label" for="name">Application Amount:</label>
                                                                <input type="text" class="form-control" v-model="application_amount" id="application_amount" placeholder="Enter Application Amount" name="application_amount" @keypress="isAmountCheck($event)">
                                                            </div>

                                                            <div class="col-sm-6 form-group mt-4">
                                                                <label class="control-label" for="name">Open Amount: &nbsp;&nbsp;${{open_amount.toFixed(2)}}</label>
                                                            </div>
                                                        </div>
                                                        <div class="form-row">
                                                            <div class="col-sm-6 form-group">
                                                                <label class="control-label" for="discount_amount">Discount Amount:</label>
                                                                <input type="text" class="form-control" v-model="discount_amount" id="discount_amount" placeholder="Enter Discount Amount" name="discount_amount" @keypress="isAmountCheck($event)">
                                                            </div>

                                                            <div class="col-sm-6 form-group mt-4">
                                                                <label class="control-label" for="name">Discount Available: &nbsp;&nbsp;{{discount_available}}</label>
                                                            </div>
                                                            </div>
                                                            <div class="form-row">
                                                            <div class="col-sm-6 form-group">
                                                                <label class="control-label" for="acc_amount">Accomodation Amount:</label>
                                                                <input type="text" class="form-control" v-model="acc_amount" id="acc_amount" placeholder="Enter Accomodation Amount" name="acc_amount" @keypress="isAmountCheck($event)">
                                                            </div>
                                                            <div class="col-sm-6 form-group">
                                                                <label class="control-label" for="gl_account">Write Off Account:</label>
                                                                <v-select v-model="gl_account_id" name="gl_account_id" id="gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                                    <template slot="no-options">
                                                                        Search GL Account...
                                                                    </template>
                                                                    <template slot="option" slot-scope="option">
                                                                        <div class="d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                    <template slot="selected-option" slot-scope="option">
                                                                        <div class="selected d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                </v-select>
                                                                <div class="field-error">{{gl_account_error_msg}}</div>
                                                            </div>
                                                        </div>
                                                        <div class="form-row">
                                                            <div class="col-sm-6">
                                                                <label class="control-label" for="late_fee">Late Fee:</label>
                                                                <input type="text" class="form-control" v-model="late_fee" id="late_fee" placeholder="Enter Late Fee" name="late_fee" @keypress="isAmountCheck($event)">
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <label class="control-label" for="gl_account">Write Off Account:</label>
                                                                <v-select v-model="late_fee_gl_account_id" name="late_fee_gl_account_id" id="late_fee_gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                                    <template slot="no-options">
                                                                        Search GL Account...
                                                                    </template>
                                                                    <template slot="option" slot-scope="option">
                                                                        <div class="d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                    <template slot="selected-option" slot-scope="option">
                                                                        <div class="selected d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                </v-select>
                                                                <div class="field-error">{{late_fee_gl_account_error_msg}}</div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div class="field-error">{{application_amount_error}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-if="findARGLMatch">
                                       
                                        <div class="form-row">
                                            <div class="col">
                                                <label class="control-label">Search JV Number</label>
                                                <div class="border-1">
                                                    <div class="form-row">
                                                        <div class="col-md-5">
                                                            <label class="control-label" for="customer_id">JV Number:</label>
                                                            <v-select v-model="al_id" name="al_id" id="al_id" label="text" :filterable="false" :options="jvArr" @search="onSearchAL" placeholder="Select Journal Voucher" @input="fetchGLWithSameAmount('al_search')" class='custom-ci-auto-search'>
                                                                <template slot="no-options">
                                                                    Search JV...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                            </template>
                                                            </v-select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-if="glMapData && glMapData.length">
                                        <p>&nbsp;</p>

                                        <div class="btn-groups mt-2 mb-2">
                                            <button v-if="selectedGLArr && selectedGLArr.length > 0" type="submit" class="btn btn-primary mapData" v-on:click.prevent="grossGLMapping(selectedGLArr,'','multiple')">Map</button>
                                        </div>
                                            <template>
                                                <table aria-describedby="table" class="table table-sm table-bordered font-1 cover">
                                                    <th>&nbsp;</th>
                                                    <th>GL Number</th>
                                                    <th>Transaction Number</th>
                                                    <th>JV Number</th>
                                                    <th>Description</th>
                                                    <th>Amount</th>
                                                    <th>Payment Date</th>
                                                    <th style="width:20px;">Action</th>
                                                <tr v-for="(glm,glndc) in glMapData" :key="glndc">
                                                    <td><input type="checkbox" id="payment" class="paymentSelect"
                                                    name="payment" :data-id="glm.id" @input="selectAccountLedger($event,glm.id,glm.payment_amount)"></td>
                                                    <td v-fp-html="glm.gl_account"></td>
                                                    <td>{{glm.transaction_number}}</td>
                                                    <td>{{glm.jv_number}}</td>
                                                    <td>{{glm.header_description}}</td>
                                                    <td>{{glm.payment_amount}}</td>
                                                    <td>{{glm.payment_date}}</td>
                                                    <td>
                                                        <template v-if="glm.is_settled == 'no'">
                                                            <a href="javascript:void(0)" v-on:click.prevent="grossGLMapping(glm.id,glm.payment_amount,'one')" class="color-blue underline" id="fullGlMap">
                                                                Full
                                                            </a>
                                                            
                                                            <span class="close-row" v-if="glm.payment_amount == 0"> - </span>
                                                        </template>
                                                        <template v-else>
                                                            <span class="close-row"> - </span>
                                                        </template>
                                                    </td>
                                                </tr>
                                                </table>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <span class="mt-3 mb-3">{{notFoundMsg}}</span>
                                        </template>
                                    </template>
                                    </div>
                                </div>
                                <div class="errorLeft">
                                    <div class="field-error">{{common_error_msg}}</div>
                                    <div class="modal-footer mt-3">
                                        <button class="btn btn-tertiary" id="okbutton" v-on:click="resetAll()" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                        <button class="btn btn-secondary" v-show="(depositRecords) && !onSettlementAccount" id="mySpecificButton" v-on:click.prevent="mapSpecificInvoiceReceipt()"> <i class="fp-import"> </i> Save</button>
                                        <button class="btn btn-secondary" v-show="(depositRecords) && onSettlementAccount" id="myNextButton" v-on:click.prevent="findNextLockbox()"> <i class="fp-next"> </i> Next</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import EventBus from ".././event-bus";

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
export default {
    name: "bankTransferList",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Bank Transfer List | " +process.env.COPYRIGHT_NAME
    },
    components: {
        vueDropzone: vue2Dropzone,



        DoughnutChart: () => import('@/components/graph/DougnutChart')
    },
    mixins:[commonMixins,dataTableMixins],
    props: {
        customerId: {
            type: String,
            required: false,
            default:undefined
        }
    },
    data: () => ({
        firstLoad : 0,
        userColumns:[],
        acc_customer_id:'',
        // customerArr:[],
        invrows:[],
        columns: [
             {
                label: 'Actions',
                field: 'action',
                sortable: false,
            },
            {
                label: 'Status',
                field: 'tag',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "# Reference", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Pending','Settled','Partial','Discarded'],
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false,
                html:true
            },
            {
                label: '#Sequence',
                field: 'id',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Sequence", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
             {
                label: '#Receipt',
                field: 'receipt_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Sequence", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: '#Account',
                field: 'account_number',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "# Reference", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['6880','0930','Other'],
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
            {
                label: 'Account Name',
                field: 'account_name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "# Reference", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
            {
                label: '#Check',
                field: 'check_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "# Reference", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: '#Payment',
                field: 'payment_no',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "# Reference", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Type',
                field: 'type',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Deposit','Withdraw','Check','Lockbox','Remote Online Deposit','Adj'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },

            {
                label: 'Customer Number',
                field: 'customer_code',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Bank", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Customer Name',
                field: 'customer_name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Bank", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Amount',
                field: 'amount',
                filterable: true,
                fpFieldType:"integer",
                type:"number",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Amount Applied',
                field: 'applied_amount',
                filterable: true,
                fpFieldType:"integer",
                type:"number",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Difference',
                field: 'balance',
                filterable: true,
                fpFieldType:"integer",
                type:"number",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Date',
                field: 'date',
                hidden:false,
                fpFieldType:"date",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Description',
                field: 'description',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Invoice Number',
                field: 'invoice_number',
                filterable: true,
                fpFieldType:"text",
                hidden:true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "inv", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            // {
            //     label: 'Discarded',
            //     field: 'discarded',
            //     filterable: true,
            //     fpFieldType:"option",
            //     hidden:false,
            //     filterOptions: {
            //         enabled: false, // enable filter for this column
            //         placeholder: "Type", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         filterDropdownItems: ['Yes','No'],
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            {
                label: 'Remarks',
                field: 'remarks',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Remarks", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true,
            },
            // {
            //     label: 'Actions',
            //     field: 'action',
            //     sortable: false,
            // },
        ],
        rows: [],
        totalRecords: 0,
        permissions:[],
        duplicateTransfer:[],
        loading:false,
        cantAccessPage:"",
        importerror:'',
        errorMsg:'',
        pageKey:"_bank_transfer_list_",
        selId : 0,
        preTarget :'',
        clickTrue:false,
        reqeustSent:0,
        invoiceFound:'',
        checkData:[],
        paymentIds:[],
        invoiceIds:[],
        invData:[],
        type:'',
        accrows:[],
        cashrows:[],
        creditrows:[],
        rowActivate:false,
        rcLeft:'',
        rcTop:'',
        onSettlementAccount:true,
        isUnit:true,
        difference:0,
        vehicleArr:[],
        gl_account_error_msg:'',
        gl_account_id:'',
        accountsArr:[],
        acc_amount:0.00,
        discount_amount:0.00,
        open_amount:0.00,
        application_amount:0.00,
        discount_available:0.00,
        idArr:[],
        invidArr:[],
        spc_invoice_id:0,
        current_open_amount:0,
        late_fee_gl_account_id:'',
        late_fee:0.00,
        adjustFlow:false,
        late_fee_gl_account_error_msg:'',
        notFoundMsg:'',
        onCash:false,
        onSecurityDeposit:false,
        onAccount:false,
        amount_applied:0,
        payment_amount:0,
        totalSelectedInvAmount :0,
        totalSelectedPayAmount:0,
        specificInvoice:false,
        alreadyMapped:false,
        expchartData :{},
        amount:0,
        description:'',
        account_no:'',
        account_name:'',
        date:'',
        onaccountView:[],
        directglView:[],
        securityview:[],
        glOfSecurity:{},
        disError:false,
        loadingModal:false,
        partialMatch:false,
        customer_id:'',
        customerArr:[],
        invoice_id:'',
        invoiceArr:[],
        customer_error_msg:'',
        mapperIdArr:[],
        mappedInvoices:[],
        mappedPayments:[],
        fromOtherPage:false,
        existingCustomer:'',
        custExist:false,
        discountId:0,
        application_amount_error:'',
        common_error_msg:'',
        lockbox:false,
        rod:false,
        disUrl:'',
        invoice_ids:[],
        doc_error_msg: "",
        uploadedFiles: "",
        dropzoneOptions: {
            url: process.env.ROOT_API +"/deposit-docs",
            method: 'POST',
            maxFilesize: 5.00, //MB
            maxFiles:1,
            thumbnailWidth: 150, // px
            thumbnailHeight: 150,
            addRemoveLinks: true,
            duplicateCheck: true,
            acceptedFiles: ".jpg, .jpeg, .png, .pdf",
            headers: {
                'Accept': 'application/json',
                "Authorization": "Bearer "+localStorage.getItem("tkn"),
                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                "Cache-Control": "no-cache"
            },
            dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
            destroyDropzone:false,
            dictDefaultMessage: "Drop files here to upload. Files upto maximum 5 MB size are allowed.",
        },
        dropZonePreviewFiles:[],
        files:[],
        isUploadShow: false,
        validateDocs:[],
        showFullAndCustom:true,
        parentId:0,
        partialAPMatch:false,
        vendorArr:[],
        vendor_id:'',
        vendor_error_msg:'',
        voucherArr:[],
        voucher_ids:'',
        ap_payments:'',
        voucherrows:[],
        paymentRows:[],
        totalSelectedVoucherAmount:0,
        voucherIds:[],
        findGLMatch:false,
        findARGLMatch:false,
        glMapData:[],
        mappedVoucher:[],
        mappedAL:[],
        jvArr:[],
        al_id:'',
        canRemoveRecords : false,
        ach:false,
        sequenceArr:[],
        sequence:'',
        sequence_error_msg:'',
        routeSelId:undefined,
        vouchercolumns:[
            {
                label: 'Vendor',
                field: 'vendor_number',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Vendor", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'Assignee',
                field: 'assignee',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Assignee", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'Voucher Number',
                field: 'voucher_number',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Voucher Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'Invoice Number',
                field: 'bill_number',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Invoice Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'Payment Number',
                field: 'payment_no',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Payment Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: '#Cheque',
                field: 'cheque_no',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "#Cheque", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
             {
                label: 'Original Amount',
                field: 'total',
                filterable: true,
                sortable:true,
                type:'number',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Original Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'Voucher Date',
                field: 'bill_date',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Voucher Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'Voucher Status',
                field: 'status',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Voucher Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
             {
                label: 'Status',
                field: 'man_status',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Voucher Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
             {
                label: 'Action',
                field: 'action',
                filterable: false,
                sortable:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Voucher Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
        ],
        paymentColumns:[
            {
                label: 'Vendor',
                field: 'vendor_number',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Vendor", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'Payment Number',
                field: 'payment_no',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Payment Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: '#Cheque',
                field: 'cheque_no',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "#Cheque", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
             {
                label: 'Original Amount',
                field: 'total',
                filterable: true,
                sortable:true,
                type:'number',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Original Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'Payment Date',
                field: 'payment_date',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Payment Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'Payment Status',
                field: 'status',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Payment Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'Action',
                field: 'action',
                filterable: false,
                sortable:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payment Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
        ],
        voucherTotalRec:0,
        totalSelectedGlAmount:0,
        selectedGLArr:[],
        allMapped:[],
        bdglView:[],
        refundView:[],
        manualActive:'',
        bankActive:'active',
        depositRecords:false,
        returnedTrans:false,
        discarded:'no',
        transactionTypeArr:[{text:'Account Receivable',value:'ar'},{text:'Account Payble',value:'ap'}],
        transaction_type:'',
        trTypeDisable:false,
        apPaymentIds:[],
        paymentArr:[],
        loadOnce:0
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_bank_transfer') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'delete_bank_transfer') {
                    self.canRemoveRecords = true;
                }
            });
        },
        // customer_id:function(){
        //     var self = this;

        //     self.onSearchInvoice('');
        // }
    },
    created: function() {
    },
    mounted: function () {

        this.getPermissions();
        if (this.$route.query != undefined) {
            if (this.$route.query.flag != undefined) {
                if (this.$route.query.value != undefined && this.$route.query.value != null) {
                    this.fromOtherPage = true;
                    if (this.$route.query.value != "") {
                        this.selId = this.$route.query.value;
                        this.routeSelId = this.$route.query.value;
                    }
                    if (this.$route.query.type != "") {
                        if (this.$route.query.type == 'manual'){
                            this.manualActive = 'active';
                            this.bankActive = '';
                        }
                    }
                }
            }
        }
    },
    methods: {
        getBankRecords:function(from){
            var self = this;
            self.bankActive = '';
            self.manualActive = '';
            if (from == 'manual'){
                self.loadList('manual')
                self.manualActive = 'active';
            }else{
                self.loadList('');
                self.bankActive = 'active';
            }
        },
        isUnitSelect(event) {
            var self = this;
            self.isUnit = event.target.checked;
        },
        onSearchSequence(search,loading){
            var self = this;
            if (search.length > 2) {
                loading(true);
                self.searchField(loading, search, 'bank sequence', '');
            }
        },
        onSearchInvoice(search) {
            var self = this;
            var customerId = 0;
            if (self.customer_id == null || self.customer_id == 0 || !self.customer_id.parent_id){
                if (search.length < 4) {
                    return;
                }
            }else{
                customerId = self.customer_id.parent_id;
            }
                // self.searchField(loading, search, 'invoice', '');
            $.ajax({
                url: process.env.ROOT_API + "/invoices/customer/search",
                type: "POST",
                headers: this.ajxHeaders,
                data: {customer_id:customerId,flag:'invoice',search:search},
                crossDomain: true,
                dataType: "json",
                success: function (data) {
                    self.invoiceArr = [];
                    if (data.status == "success") {
                        self.invoiceArr = data.content;
                    }else{
                        self.invoiceArr = [];
                    }

                },
                error: function (jqXHR, exception) {
                    loading(false);
                    self.generateStatusCodeMessage(jqXHR,true,'customer-invoice-search');
                }
            });
        },
        expandthis(params,flag=''){
            var self = this;
            if (params.event != undefined && params.event.target != undefined && $(params.event.target).attr('class') == 'vgt-checkbox-col'){
                return;
            }
            if (params.row.lbx != undefined && params.row.lbx == 'yes'){
                self.getLockboxData(params,params.row.id);
                if (params.row.id){
                    self.parentId = params.row.id;
                }
            }else{
                // alert(params.row.description);
                // alert(params.row.description.toLowerCase().includes('lock box'));
                if ((params.row.description.toLowerCase().includes('lock box') == true || params.row.description.toLowerCase().includes('lockbox') == true || params.row.description.toLowerCase().includes('remote online') == true)){
                    alert('Please upload breakdown');
                }else{
                    self.expandView(params,flag);
                }
            }


        },

        findNextLockbox:function(){
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/fetch-next-lockbox",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    id:self.selId
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == 'success'){
                        self.selId = data.content.id;
                        self.type = data.content.type;
                        self.amount = data.content.amount;
                        self.description = data.content.description;
                        self.account_no = data.content.account_number;
                        self.account_name = data.content.account_name;
                        self.date = data.content.date;
                        self.existingCustomer = '';
                        self.customer_id = '';
                        self.custExist = false;
                        self.loadReceiptItem();
                        setTimeout(function(){
                            var link  = $("#row-id-"+self.parentId);
                            link.click();
                            link.click();
                        },200);
                    }else{
                        self.$swal('','No Pending item found for this payment','info');
                        return;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'fetch-next-items')
                }
            });

        },

        expandView:function(params , flag = ''){
            var self = this;

            // console.log(params.event);
            self.selId = params.row.id;
            self.type = params.row.type;
            self.amount = params.row.amount;
            self.description = params.row.description;
            self.account_no = params.row.account_number;
            self.account_name = params.row.account_name;
            self.date = params.row.date;
            self.difference = params.row.ori_amount;
            self.discarded = params.row.discarded;
            var tr_type = params.row.tr_type;
            self.notFoundMsg = '';
            self.glOfSecurity = {};
            self.customer_id = '';
            self.customerArr = [];
            self.invoiceIds = [];
            self.partialMatch = false;
            self.invrows = [];
            self.mappedInvoices = [];
            self.mappedPayments = [];
            self.existingCustomer = '';
            self.mapperIdArr = [];
            self.discountId = 0;
            self.application_amount_error = '';
            //to prevent any action on discarded records
            if (self.discarded.toLowerCase() == 'yes'){
                self.$swal('','Record is discarded','info');
                return;
            }

            $("#myBankModal").modal('show');

            if (params.row.status != 'pending'){
                self.trTypeDisable = true;
            }else{
                self.trTypeDisable = false;
            }

            //display all the option in withdraw type if account number contains 6880

            // as discussed with elicia on call to display withdraw type option in modal
            // if (self.account_no != '' && self.account_no.includes('6880') && self.type != 'Deposit' && self.type != 'Lockbox'){
            //     self.type = 'Return';
            // }

            // if (params.row.type != 'Check'){
                // const toggleSwitch = document.querySelectorAll('.findmatch input[type="radio"]');
                // console.log(toggleSwitch);
                $(".findmatch").prop('checked', false);

                setTimeout(function(){
                    if (self.type != 'Deposit' && self.type != 'Ach' && self.type != 'Lockbox' && self.type != 'Remote Online Deposit' && self.type != 'Return' && !self.description.toLowerCase().includes('returned debit')){
                        $("#rbsettlementacctp").click();
                        self.transaction_type = {text:'Account Payble',value:'ap'};
                        self.depositRecords = false;
                    }else{
                        $("#rbsettlementacct").click();
                        self.depositRecords = true;
                        self.transaction_type = {text:'Account Receivable',value:'ar'};
                    }

                    if (tr_type != null && tr_type == 'ar'){
                        self.transaction_type = {text:'Account Receivable',value:'ar'};
                        $("#rbsettlementacct").click();
                        self.depositRecords = true;
                    }
                    if (tr_type != null && tr_type == 'ap'){
                        self.transaction_type = {text:'Account Payble',value:'ap'};
                        $("#rbsettlementacctp").click();
                        self.depositRecords = false;
                    }
                },300);

                if (self.description.toLowerCase().includes('returned debit')){
                    self.returnedTrans = true;
                }else{
                    self.returnedTrans = false;
                }

            // }
            // $( params.event.target.closest('.clickable')).addClass("adjustColor");

            // if ( $( params.event.target.closest('.clickable')).hasClass("mapReceiptModal")) {
            //     $( params.event.target.closest('.clickable')).remove();
            // }else{
            //     $( params.event.target.closest('.clickable')).addClass("mapReceiptModal");
            // }
            var pos = params.event;
            // self.rcLeft = pos.clientX - ;
            if (flag != 'expand'){
                self.rcTop = pos.clientY + 21;
            }

            self.rowActivate = true;
            // $(document).off("click", "a.deposit");
            // $(document).off("click", "a.onaccount" )
            // $(document).off("click", "a.glentry")
            // $(document).off("click", "a.settleInvoice")

            // $(document).off("click", "input.findmatch");
            // $(document).off("click", "input.paymentSelect");
            // $(document).off("click", "input.mapData");

            // if (self.preTarget != ''){
            //     self.checkData = [];
            //     self.invData = [];
            //     if ( $(self.preTarget.closest('.clickable').nextSibling).hasClass("receiptBlock")) {
            //         $(self.preTarget.closest('.clickable').nextSibling).remove();
            //         if (self.selId != 0 && self.selId == params.row.id && flag == ''){
            //             return;
            //         }
            //     }
            // }
            // if (params.row.type == 'Check' && flag == ''){
            //     self.fetchCheck(params.row.id,params)
            // }else{
                // var html = '';
                // html = $(".receiptBlock").clone();
                // self.preTarget = params.event.target;
                // $(html).insertAfter(params.event.target.closest('.clickable'));

            //     self.createAllEvent(params);
            // }
            self.onCash = false;
            self.onSecurityDeposit=false;
            self.onAccount=false;
            self.specificInvoice = false;
            self.checkData = [];
            self.invData = [];
            // if (params.row.type == 'Check'){
            //     // self.fetchCheck(params.row.id,params)
            // }else if(params.row.type == 'Payment'){

            // }else{
            //     // self.loadReceiptItem();
            // }


            $( document ).ready(function() {
                // change div color to blue on page ready
                $(".mapReceiptModal").addClass('wo-vendorinv-form');
                $(".modal-backdrop").removeClass('show');
                $(".modal-backdrop").addClass('hide');
            });
            self.settlementAccount();
        },

        getLockboxData: function(params,id){
            var self = this;

            if ($(params.event.target.closest('.clickable')) != null) {
                if ($(params.event.target.closest('.clickable').nextSibling) != null) {
                    if ( $(params.event.target.closest('.clickable').nextSibling).hasClass("lockBoxDetail")) {
                        $(params.event.target.closest('.clickable').nextSibling).remove();//table 1
                        $(params.event.target.closest('.clickable').nextSibling).remove();//table 2
                        return;
                    }
                }
            }

            //generate html
            var html = '<tr class="lockBoxDetail"><td colspan="8"><table aria-describedby="table" class="table">';

            $.ajax({
                url: process.env.ROOT_API + "/fetch-lockbox",
                type: "GET",
                headers: this.ajxHeaders,
                data:{
                    id:id
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if ( data.code == 200 ) {

                            //check data records
                        var lockBoxMainArr = [];
                        var lockBoxEntryArr = [];
                        if ( data.content.length > 0 ) {

                            for ( var j=0; j<data.content.length; j++ ) {
                                if (data.content[j].row.type.toLowerCase() == "lockbox main" || data.content[j].row.type.toLowerCase() == "remote online deposit main" || data.content[j].row.type.toLowerCase() == "ach main") {
                                    lockBoxMainArr.push(data.content[j].row);
                                }else{
                                    lockBoxEntryArr.push(data.content[j].row);
                                }
                            }

                        } else {
                            html += '<tr><th>Status</th><th>#Sequence</th><th>#Account</th><th>Account Name</th><th>#Payment</th><th>Type</th><th class="text-right">Amount</th><th class="text-right">Amount Applied</th><th class="text-right">Difference</th><th>Date</th><th>Description</th></tr>';
                            html += '<tr><td colspan="8">No record found.</td></tr>';
                        }
                        //lockbox main entry
                        if (lockBoxMainArr.length > 0) {
                            html += '<tr><th>#Sequence</th><th>#Account</th><th>Account Name</th><th>#Payment</th><th>Type</th><th class="text-right">Amount</th><th class="text-right">Amount Applied</th><th class="text-right">Difference</th><th>Date</th><th>Description</th></tr>';
                            for ( var j=0; j<lockBoxMainArr.length; j++ ) {
                                html += '<tr class="lbx-main-row-section" id="lbx-main-row-'+lockBoxMainArr[j].id+'"><td>'+lockBoxMainArr[j].id+'</td><td>'+lockBoxMainArr[j].account_number+'</td><td>'+lockBoxMainArr[j].account_name+'</td><td>'+lockBoxMainArr[j].payment_no+'</td><td>'+lockBoxMainArr[j].type+'</td><td class="vgt-right-align">'+lockBoxMainArr[j].amount+'</td><td class="vgt-right-align">'+lockBoxMainArr[j].applied_amount+'</td><td class="vgt-right-align">'+lockBoxMainArr[j].balance+'</td><td>'+lockBoxMainArr[j].date+'</td><td>'+lockBoxMainArr[j].description+'</td></tr>';
                            }
                            html += '</table></td></tr>';
                            html += '<tr class="lockBoxDetail"><td colspan="8"><table aria-describedby="table" class="table">';
                            //lockbox entry
                            if (lockBoxEntryArr.length > 0) {
                                html += '<tr><th>Status</th><th>#Sequence</th><th>#Account</th><th>Account Name</th><th>#Payment</th><th>Type</th><th class="text-right">Amount</th><th class="text-right">Amount Applied</th><th class="text-right">Difference</th><th>Date</th><th>Description</th></tr>';
                                for ( var j=0; j<lockBoxEntryArr.length; j++ ) {
                                    html += '<tr class="expand-row-section" id="expanded-row-'+lockBoxEntryArr[j].id+'"><td>'+lockBoxEntryArr[j].tag+'</td><td>'+lockBoxEntryArr[j].id+'</td><td>'+lockBoxEntryArr[j].account_number+'</td><td>'+lockBoxEntryArr[j].account_name+'</td><td>'+lockBoxEntryArr[j].payment_no+'</td><td>'+lockBoxEntryArr[j].type+'</td><td class="vgt-right-align">'+lockBoxEntryArr[j].amount+'</td><td class="vgt-right-align">'+lockBoxEntryArr[j].applied_amount+'</td><td class="vgt-right-align">'+lockBoxEntryArr[j].balance+'</td><td>'+lockBoxEntryArr[j].date+'</td><td>'+lockBoxEntryArr[j].description+'</td></tr>';
                                }
                            }
                        }else{
                            //lockbox entry
                            if (lockBoxEntryArr.length > 0) {
                                html += '<tr><th>Status</th><th>#Sequence</th><th>#Account</th><th>Account Name</th><th>#Payment</th><th>Type</th><th class="text-right">Amount</th><th class="text-right">Amount Applied</th><th class="text-right">Difference</th><th>Date</th><th>Description</th></tr>';
                                for ( var j=0; j<lockBoxEntryArr.length; j++ ) {
                                    html += '<tr class="expand-row-section" id="expanded-row-'+lockBoxEntryArr[j].id+'"><td>'+lockBoxEntryArr[j].tag+'</td><td>'+lockBoxEntryArr[j].id+'</td><td>'+lockBoxEntryArr[j].account_number+'</td><td>'+lockBoxEntryArr[j].account_name+'</td><td>'+lockBoxEntryArr[j].payment_no+'</td><td>'+lockBoxEntryArr[j].type+'</td><td class="vgt-right-align">'+lockBoxEntryArr[j].amount+'</td><td class="vgt-right-align">'+lockBoxEntryArr[j].applied_amount+'</td><td class="vgt-right-align">'+lockBoxEntryArr[j].balance+'</td><td>'+lockBoxEntryArr[j].date+'</td><td>'+lockBoxEntryArr[j].description+'</td></tr>';
                                }
                            }
                        }

                        html += '</table></td></tr>';
                        $(html).insertAfter(params.event.target.closest('.clickable'));

                        $(".expand-row-section").click(function(elm) {
                            console.log(elm.currentTarget.id);
                            // console.log($(elm.target).attr("data-row-id"));
                            // var rowObj = $(elm.target).attr("data-row-id");
                            var rowObj = elm.currentTarget.id;

                            for ( var k=0; k<data.content.length; k++ ) {
                                if ( rowObj != undefined && rowObj != null && rowObj == 'expanded-row-'+data.content[k].row.id ) {
                                    self.expandthis(data.content[k],'expand');
                                }
                            }
                        })
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'fetch-lockbox-items')
                }
            });

        },

        createAllEvent:function(params){
            var self = this;
            // $(document).ready(function(){
            //     $(document).on("click", "a.deposit" , function() {
            //         self.creditDeposit();
            //     });
            //     $(document).on("click", "a.onaccount" , function() {
            //         self.onAccountMap();
            //     });
            //     $(document).on("click", "a.glentry" , function() {
            //         alert('option 3 clicked');
            //     });
            //     $(document).on("click", "a.settleInvoice" , function() {
            //         alert('option 3 clicked');
            //     });
            //     if (params.row.type == 'Check'){
            //         $('.findmatchOption').addClass('hide');
            //     }else{
            //         $('.findmatchOption').removeClass('hide');
            //     }
            //     $(document).on("click", "input.findmatch" , function() {
            //         self.fetchOpenInvoices(params.row.id,params.row.type,params);
            //     });
            //     $(document).on("click", "input.paymentSelect" , function(obj) {
            //         self.paymentSelected(obj,params.row.id,'payment');
            //     });
            //     $(document).on("click", "input.mapData" , function() {
            //         self.mapRecords(params.row.id,params.row.type);
            //     });
            // });
        },
        onAccountApp:function(){
            var self = this;
            $.ajax({
                url: process.env.ROOT_API + "/fetch-bank-mapped/items",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    flag:'on_cash',
                    item:self.selId
                },
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    // if (data.status == "exist") {

                    // self.$swal('','Already Mapped with GL','info');
                    // } else{
                        // self.cashrows = [];
                        self.onCash = false;
                        self.onSecurityDeposit = false;
                        self.invData = [];
                        self.specificInvoice = false;
                        self.onSettlementAccount = false;
                        self.partialMatch = false;
                        self.findARGLMatch = false;
                        self.disError = false;
                        // if (!self.accrows.length){
                            self.onAccount = true;
                        //     self.accrows.push({
                        //         mapper_id: 0,
                        //         acc_customer_id: '',
                        //         customer_error_msg: "",
                        //         description: "",
                        //         amount: 0.00,
                        //         amount_error_msg:'',
                        //     });
                        // }else{
                        //     self.accrows = [];
                        //     self.onAccount = false;
                        // }
                    // }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'fetch-mapped-items')
                }
            });
        },

        onSearchAccount(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'accounts', '');
            }
        },
        onSearchCustomer(search, loading) {
            var self = this;

            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'customer', '');
            }
        },
        onSearchVendor(search, loading) {
            var self = this;

            if (search.length > 2) {
                loading(true);
                self.searchField(loading, search, 'vendor', '');
            }
        },
        onSearchVoucher(search, loading) {
            var self = this;

            if (search.length > 2) {
                loading(true);
                self.searchField(loading, search, 'paid vendor invoice', '');
            }
        },
        onSearchPayment(search, loading) {
            var self = this;

            if (search.length > 2) {
                loading(true);
                self.searchField(loading, search, 'paid vendor payment', '');
            }
        },
        
        getVouchers:function(from){
            var self = this;
            var invArr = [];
            var vendor_id = 0;
            self.voucherIds = [];
            if ( self.vendor_id != null && self.vendor_id.value ){
                vendor_id = self.vendor_id.value;
            }
            if (from == 'payment'){
                if (self.ap_payments.length > 0){
                    invArr = self.ap_payments;
                }
            }else{
                if (self.voucher_ids.length > 0){
                    invArr = self.voucher_ids;
                }
            }
            

            self.loadingModal = true;
            $.ajax({
                url: process.env.ROOT_API + "/get-bank-rec-vouchers",
                type: "GET",
                headers: this.ajxHeaders,
                data:{
                    vendor_id:vendor_id,
                    rec_id:self.selId,
                    invoices:invArr,
                    from:from
                },
                dataType: "json",
                success: function (data) {
                    self.loadingModal = false;
                    if (data.status == "success") {
                        self.voucherrows = data.content.inv;
                        if (self.voucherrows != undefined && self.voucherrows.length > 0){
                            self.voucherTotalRec = self.voucherrows.length - 1;
                        }
                        self.paymentRows = data.content.inv;
                        self.loadReceiptItem();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loadingModal = false;
                    self.generateStatusCodeMessage(jqXHR,true,'customer-invoice-items');
                }
            });
        },
        onSearchVehicle(search, loading) {
            var self = this;

            if (search.length > 3) {

                loading(true);
                self.searchField(loading, search, 'vehicle', '');
            }
        },
        settlementAccount:function(){
            var self = this;
            self.onSettlementAccount = true;
            self.onSecurityDeposit = false;
            self.onCash = false;
            self.onAccount = false;
            self.invData = [];
            self.specificInvoice = false;
            self.partialMatch = false;
            self.disError = false;
            self.findARGLMatch = false;
            console.log("LOAD == 1");
            self.loadReceiptItem();
            self.alreadyMapped = true;
            self.application_amount_error = '';
            self.partialAPMatch = false;
            self.findGLMatch = false;
            self.glMapData = [];
        },
        creditDeposit:function(){
            var self = this;
            self.onSettlementAccount = false;
            self.onSecurityDeposit = true;
            self.onCash = false;
            self.onAccount = false;
            self.invData = [];
            self.specificInvoice = false;
            self.findARGLMatch = false;
            self.disError = false;
            self.partialMatch = false;
            self.application_amount_error = '';
            // $.ajax({
            //     url: process.env.ROOT_API + "/fetch-security-gl",
            //     type: "GET",
            //     headers: {
            //         "Accept": "application/json",
            //         "Authorization": "Bearer " + localStorage.getItem("tkn"),
            //         "Access-Control-Allow-Headers":
            //             "Origin, Content-Type, Authorization,X-Requested-With",
            //         "Cache-Control": "no-cache"
            //     },
            //     dataType: "json",
            //     success: function (data) {
            //         self.loading = false;
            //         console.log(data);
            //         if (data.content){
            //             self.creditrows = [];
            //             self.onSecurityDeposit = true;
            //             self.onCash = false;
            //             self.onAccount = false;
            //             if (!self.creditrows.length){
            //                 self.creditrows.push({
            //                     mapper_id: 0,
            //                     gl_account_id: {text:data.content.code+ ' | '+data.content.description,value:data.content.id},
            //                     vehicle_id: '',
            //                     customer_id: "",
            //                     customer_error_msg:'',
            //                     amount: 0.00,
            //                     amount_error_msg:'',
            //                 });
            //             }else{
            //                 self.creditrows = [];
            //                 self.onSecurityDeposit = false;
            //             }
            //         }

            //     },
            //     error: function (jqXHR, exception) {
            //         self.loading = false;
            //         self.generateStatusCodeMessage(jqXHR,false,'fetch-mapped-items')
            //     }
            // });

        },
        cashFlow:function(){
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/fetch-bank-mapped/items",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    flag:'account',
                    item:self.selId
                },
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    // if (data.status == "exist") {

                    // self.$swal('','Already Mapped with on account to customer','info');
                    // } else{
                        // self.accrows = [];
                        self.onAccount = false;
                        self.onSecurityDeposit = false;
                        // self.invData = [];
                        self.specificInvoice = false;
                        self.onSettlementAccount = false;
                        self.partialMatch = false;
                        self.disError = false;
                        self.application_amount_error = '';
                        self.findARGLMatch = false;
                        // // self.rows = [];
                        // if (!self.cashrows.length){
                            self.onCash = true;
                        //     self.cashrows.push({
                        //         mapper_id: 0,
                        //         gl_account_id: '',
                        //         account_error_msg: "",
                        //         description: "",
                        //         tax:0.00,
                        //         amount: 0.00,
                        //         amount_error_msg:'',
                        //     });
                        // }else{
                        //     self.cashrows = [];
                        //     self.onCash = false;
                        // }
                    // }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'fetch-mapped-items')
                }
            });
        },

        fetchOpenInvoices:function(id,type){
            var self = this;
            self.loadingModal = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice-amount/fetch",
                type: "POST",
                data: {
                    id:id,
                    type:type
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.reqeustSent = 0;
                    self.loadingModal = false;
                    if ( data.code == 200 ) {
                        //check data records
                        self.specificInvoice = false;
                        self.invData = [];
                        self.onAccount=false;
                        self.onCash = false;
                        self.onSecurityDeposit = false;
                        self.application_amount_error = '';
                        if ( data.content ) {
                            // $('.invoiceFoundMsg').html(data.content);
                            if (type == 'Deposit' || type == 'Lockbox' || type == 'Ach' || type == 'Remote Online Deposit'){
                                self.invData = data.content;
                            }else{
                                self.checkData = data.content;
                            }

                            // if ( $(self.preTarget.closest('.clickable').nextSibling).hasClass("receiptBlock")) {
                            //         $(self.preTarget.closest('.clickable').nextSibling).remove();
                            // }
                            // setTimeout(function(){
                            //     var html = '';
                            //     html = $(".receiptBlock").clone();
                            //     self.preTarget = params.event.target;
                            //     $(html).insertAfter(params.event.target.closest('.clickable'));
                            //     self.createAllEvent(params);
                            // },1000);

                        }
                    }else{
                        self.invData = [];
                        self.checkData = [];
                        self.notFoundMsg = '';
                        self.disError = true;
                        self.notFoundMsg = 'No Data Found';
                    }
                },
                error: function (jqXHR, exception) {

                    self.reqeustSent = 0;

                    self.loadingModal = false;
                    self.generateStatusCodeMessage(jqXHR,true,'past-due-notice-details');
                }
            });
        },
        checkFindMatch:function(evt){
            var self = this;
            self.onSettlementAccount = false;
            self.partialMatch = false;
            self.partialAPMatch = false;
            self.findARGLMatch = false;
            self.voucherrows = [];
            self.paymentRows = [];
            self.vendor_id = '';
            self.findGLMatch = false;
            self.glMapData = [];
            self.voucherIds = [];
            self.invData = [];
            self.disError = false;
            if (evt.target.checked == true){
                if (self.type != '' && (self.type == 'Deposit' || self.type == 'Lockbox' || self.type == 'Ach' || self.type == 'Remote Online Deposit')){
                    self.onCash = false;
                    self.onAccount = false;
                    self.onSecurityDeposit = false;
                    self.specificInvoice = false;
                    self.application_amount_error = '';
                    self.fetchOpenInvoices(self.selId,self.type);
                }else if (self.type != '' && self.type == 'Withdraw'){
                    self.fetchOpenInvoices(self.selId,self.type);
                }else{
                    self.fetchCheck(self.selId);
                }
            }
        },
        fetchCheck:function(id){
            var self = this;
            self.loadingModal = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice-amount/fetch",
                type: "POST",
                data: {
                    id:id,
                    type:'Check'
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.reqeustSent = 0;
                    self.loadingModal = false;
                    if ( data.code == 200 ) {
                        //check data records
                        if ( data.content ) {
                                self.checkData = data.content;
                            // if ( $(params.event.target.closest('.clickable').nextSibling).hasClass("receiptBlock")) {
                            //         $(params.event.target.closest('.clickable').nextSibling).remove();
                            // }
                            // setTimeout(function(){
                            //     var html = '';
                            //     html = $(".receiptBlock").clone();
                            //     self.preTarget = params.event.target;
                            //     $(html).insertAfter(params.event.target.closest('.clickable'));
                            //     self.createAllEvent(params);
                            // },1000);
                        }
                    }else{
                        self.notFoundMsg = '';
                        self.disError = true;
                        self.notFoundMsg = 'No Data Found';
                    }
                },
                error: function (jqXHR, exception) {

                    self.reqeustSent = 0;

                    self.loadingModal = false;
                    self.generateStatusCodeMessage(jqXHR,true,'past-due-notice-details');
                }
            });
        },
        cancelAll: function (cancelAll) {
          this.$refs.listbankTransferTable.unselectAllInternal();
        },
        selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
        loadList(from) {
            var self = this;
            if (from != 'cancel'){
                $('table tr.lockBoxDetail').remove();
            }
            //to handle display active tab's records display on reset button click
            if (from == 'adjust' || from == 'load' || from == 'cancel' || from == 'defaultfilter'){
                if (self.manualActive == 'active'){
                    from = 'manual';
                }else{
                    from = 'bank';
                }
            }
            self.loading = true;
            var custId = null;

            if (self.customerId != undefined){
                custId = self.customerId;
            }
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                customer_id:custId,
                from:from
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/bank-transfer/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                        self.filteredFlag = false;
                        //view record from general ledger
                        if (self.fromOtherPage) {
                            if (self.rows.length > 0) {
                                if (self.selId > 0) {
                                    var idx = self.rows.findIndex(obj => obj.id == self.selId);
                                    if (idx != -1 ){
                                        if (self.rows[idx] != null) {
                                            var obj = {};
                                            obj.row = self.rows[idx];
                                            self.bankTransferDetail(obj);
                                        }
                                    }
                                }
                            }
                            self.fromOtherPage = false;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'bank-transferlist');
                }
            });
        },

        paymentSelected:function(evt,rcId,flag,amountSelected){
            var self = this;
            // var rcId = $(evt.target).attr("data-id");
            // var rcId = evt.target.value;

            if (flag == 'payment_map'){
                self.paymentIds.push({id:rcId});

                self.mapRecords(self.selId,'Withdraw');
            }else{
                if(evt.target.checked == true){
                    if (flag == 'payment'){
                        self.paymentIds.push({id:rcId});
                    }else{
                        self.totalSelectedInvAmount += amountSelected;
                        if (self.totalSelectedInvAmount > self.difference){
                            self.$swal('','Selected invoice amount is greater than remaining payment amount','info');
                            evt.target.checked = false;
                            self.totalSelectedInvAmount -= amountSelected;
                            return;
                        }
                        self.invoiceIds.push({id:rcId});
                    }
                }else{
                    if (flag == 'payment'){
                        var i = self.paymentIds.indexOf(rcId);
                        const filteredItems = self.paymentIds.filter(function(item) {
                            return item.id !== rcId
                        })
                        self.paymentIds = filteredItems;
                    }else{
                        self.totalSelectedInvAmount -= amountSelected;
                        var i = self.invoiceIds.indexOf(rcId);
                        const filteredItems = self.invoiceIds.filter(function(item) {
                            return item.id !== rcId
                        })
                        self.invoiceIds = filteredItems;
                    }
                }
            }
            console.log(self.invoiceIds);
        },

        mapRecords:function(bank_rec_id,flag){
            var self = this;
            var recId = [];
            if (flag == 'Deposit' || flag == 'Lockbox' || flag == 'Ach' || flag == 'Return' || flag == 'Remote Online Deposit'){
                recId = self.invoiceIds;
            }else{
                recId = self.paymentIds;
            }
            $.ajax({
                url: process.env.ROOT_API + "/record/map",
                type: "POST",
                data: {
                    record_id:recId,
                    id:bank_rec_id,
                    flag:flag,
                    tr_type:self.transaction_type.value
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    self.trTypeDisable = true;
                    if (data.status == "success") {
                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                        }
                    //    self.paymentSelected('',bank_rec_id,flag);
                    if (flag != '' && (flag == 'Deposit' || flag == 'Lockbox' || flag == 'Ach' || flag == 'Remote Online Deposit')){
                        self.totalSelectedInvAmount = 0;
                        self.invoiceIds = [];
                        self.mapperIdArr = [];
                        self.fetchOpenInvoices(bank_rec_id,flag);
                    }else if (flag != '' && flag == 'Withdraw'){
                        self.fetchOpenInvoices(bank_rec_id,'Withdraw');
                        setTimeout(function(){
                            $("#rbsettlementacctp").click();
                        },1000);
                    }else{
                        self.fetchCheck(bank_rec_id);
                        setTimeout(function(){
                            $("#rbsettlementacctp").click();
                        },1000);
                    }
                       self.invoiceIds = [];
                       self.paymentIds = [];
                    }
                    self.loadList('load');
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'record-map');
                }
            });
        },
        onFileChanged (event) {
            const file = event.target.files[0]
            console.log(event.target);
            var self = this;
            self.selectedFile = file;
            self.notfound = false;
            self.notFoundArr = [];
            console.log(self.selectedFile);
        },
        importTransfers: function(){
                var self = this;
                self.sequence_error_msg = '';
                if(self.selectedFile != ""){

                    var file = self.selectedFile.name.split('.');
                    var selectedFileType = file[file.length -1];
                    if(selectedFileType === "xlsx" || selectedFileType === "xls" || selectedFileType === "csv"){

                        var formData = new FormData();
                        formData.append('myFile', self.selectedFile);
                        formData.append('lockbox', self.lockbox);
                        formData.append('rod', self.rod);
                        formData.append('ach', self.ach);

                        if (self.ach == true && self.sequence != '' && self.sequence != null && self.sequence.value){
                            formData.append('sequence', self.sequence.value);
                        }else{
                            if (self.ach == true){
                                self.sequence_error_msg = 'Please select transaction sequence';
                                return;
                            }
                            formData.append('sequence', '');
                        }

                        self.loading = true;
                        $('#myButton').text('Fetching...');
                        $('#myButton').prop('disabled',true);
                        $.ajax({
                        url: process.env.ROOT_API + "/bank-transfer/import",
                        type: "POST",
                        data: formData,
                        headers: this.ajxHeaders,
                        crossDomain: true,
                        processData: false,
                        contentType: false,
                        dataType: "json",
                        success: function (data) {
                            $('#myButton').text('Import');
                            $('#myButton').prop('disabled',false);
                            self.loading = false;
                            if (data.status == 'wrong_format'){
                                self.$swal('',data.message,'info');
                                return;
                            }
                            if (data.status == "success") {

                                if (data.dateerror){
                                    self.importerror = data.message;
                                    self.disUrl = data.errorurl;
                                }else
                                if (data.sheetexist){

                                    self.importerror = data.message;

                                }else if (!data.sheetexist && data.code == 201){
                                    self.importerror = data.message;
                                } else if (data.duplicate != null && Object.keys(data.duplicate).length == 0 && data.content == 0) {

                                    self.importerror = "Sheet format does not match";

                                }else{
                                    if(data.content != false){
                                        self.$swal('',data.content+" Records imported",'success');
                                    }else{
                                        self.$swal('',"Records imported",'success');
                                    }
                                    self.error = "";
                                    $('#myModal').modal('hide');
                                    self.loadList('load');
                                }

                            }else{
                                if (data.content == 'parent_not_found'){
                                    self.importerror = data.message;
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            $('#myButton').text('Import');
                            $('#myButton').prop('disabled',false);
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'bank-transferimport');
                        }
                    });
            } else{
                self.importerror = "Please upload file with extension xlsx, xsl.";
            }
        }else {
            self.importerror = "Please select the file."
        }

        },
        addRow: function (flag) {

            var self = this;
            if (flag == 'on_cash'){
                var index = self.cashrows.length - 1;

                self.cashrows[index].account_error_msg = "";
                self.cashrows[index].amount_error_msg = "";

                if (self.cashrows[index].gl_account_id != null && self.cashrows[index].gl_account_id != '' && self.cashrows[index].gl_account_id.value && self.cashrows[index].amount &&
                    self.cashrows[index].amount != '' && self.cashrows[index].amount != 0 ) {

                    self.cashrows.push({
                        mapper_id: 0,
                        gl_account_id: '',
                        account_error_msg: "",
                        description: "",
                        tax:0.00,
                        amount: 0.00,
                        amount_error_msg:'',
                    });

                } else {
                    if (self.cashrows[index].gl_account_id == null || !self.cashrows[index].gl_account_id.value) {
                        self.cashrows[index].account_error_msg = "GL Account is Required.";
                    }
                    if (self.cashrows[index].amount == null || !self.cashrows[index].amount) {
                        self.cashrows[index].amount_error_msg = "Amount is Required.";
                    }
                }
            }
            if (flag == 'on_account'){
                var index = self.accrows.length - 1;

                self.accrows[index].account_error_msg = "";
                self.accrows[index].amount_error_msg = "";

                if (self.accrows[index].acc_customer_id != null && self.accrows[index].acc_customer_id != '' && self.accrows[index].acc_customer_id.value && self.accrows[index].amount &&
                    self.accrows[index].amount != '' && self.accrows[index].amount != 0 ) {

                    self.accrows.push({
                        mapper_id: 0,
                        acc_customer_id: self.accrows[0].acc_customer_id,
                        is_disable:true,
                        customer_error_msg: "",
                        description: '',
                        amount: '',
                        amount_error_msg:'',
                        is_cancelled:'no'
                    });

                } else {
                    // console.log(self.rows[i]);
                    self.accrows[index].customer_error_msg = "";
                    self.accrows[index].amount_error_msg = "";

                    if (self.accrows[index].acc_customer_id == null || !self.accrows[index].acc_customer_id.value) {
                        self.accrows[index].customer_error_msg = "Customer is Required.";
                    }
                    if (self.accrows[index].amount == null || !self.accrows[index].amount) {
                        self.accrows[index].amount_error_msg = "Amount is Required.";
                    }
                }
            }
            if (flag == 'security'){
                var index = self.creditrows.length - 1;

                self.creditrows[index].account_error_msg = "";
                self.creditrows[index].amount_error_msg = "";
                self.creditrows[index].description_error_msg = "";

                if (self.creditrows[index].customer_id != null && self.creditrows[index].customer_id != '' && self.creditrows[index].customer_id.value && self.creditrows[index].amount &&
                    self.creditrows[index].amount != '' && self.creditrows[index].amount != 0 ) {

                    self.creditrows.push({
                        mapper_id: 0,
                        gl_account_id: self.glOfSecurity,
                        customer_id: self.creditrows[0].customer_id,
                        is_disable:true,
                        customer_error_msg: "",
                        vehicle_id:'',
                        amount: '',
                        amount_error_msg:'',
                        description_error_msg:'',
                        description:'',
                        is_cancelled:'no'
                    });
// glOfSecurity
                } else {
                    // console.log(self.rows[i]);
                    self.creditrows[index].customer_error_msg = "";
                    self.creditrows[index].amount_error_msg = "";
                    self.creditrows[index].description_error_msg = "";

                    if (self.creditrows[index].customer_id == null || !self.creditrows[index].customer_id.value) {
                        self.creditrows[index].customer_error_msg = "Customer is Required.";
                    }
                    if (self.creditrows[index].amount == null || !self.creditrows[index].amount) {
                        self.creditrows[index].amount_error_msg = "Amount is Required.";
                    }
                }
            }

        },
        removeElement: function (index,flag) {
            var self = this;
            if (flag == 'on_cash'){
                if (self.cashrows.length > 0) {
                    if (self.cashrows[index].mapper_id == 0) {
                        self.cashrows.splice(index, 1);

                    } else {
                        if (confirm('Are you sure that you want to delete this Item? ')) {
                            self.idArr = [];
                            self.idArr.push({id:self.cashrows[index].mapper_id});
                            self.cancelReceiptPayment('on_cash');
                            self.cashrows.splice(index, 1);
                        }
                    }
                }
            }
            if (flag == 'on_account'){
                if (self.accrows.length > 0) {
                    if (self.accrows[index].mapper_id == 0) {
                        self.accrows.splice(index, 1);

                    } else {
                        if (confirm('Are you sure that you want to delete this Item? ')) {
                            self.idArr = [];
                            self.idArr.push({id:self.accrows[index].mapper_id});
                            self.cancelReceiptPayment('on_account');
                            self.accrows.splice(index, 1);
                        }
                    }
                }
            }
            if (flag == 'security'){
                if (self.creditrows.length > 0) {
                    if (self.creditrows[index].mapper_id == 0) {
                        self.creditrows.splice(index, 1);

                    } else {
                        if (confirm('Are you sure that you want to delete this Item? ')) {
                            self.idArr = [];
                            self.idArr.push({id:self.creditrows[index].mapper_id});
                            self.cancelReceiptPayment('security');
                            self.creditrows.splice(index, 1);
                        }
                    }
                }
            }

        },
        cancelReceiptPayment:function(flag){
            var self = this;
            var ids = self.idArr;
            if (flag == 'deposit' || flag == 'settle'){
                if (self.mapperIdArr.length){
                    for(var i =0;i<self.mapperIdArr.length; i++){
                        if (self.mapperIdArr[i].open_amount != undefined && self.mapperIdArr[i].inv_amount != undefined){
                            if (self.mapperIdArr[i].open_amount == self.mapperIdArr[i].inv_amount && !self.returnedTrans){
                                self.$swal('','Please select mapped invoice to cancel','info');
                                return;
                            }
                        }
                    }
                }

                ids = self.mapperIdArr;
            }
            self.loadingModal = true;
            if (self.loadOnce == 1){
                return;
            }
            self.loadOnce = 1;
            $.ajax({
                url: process.env.ROOT_API + "/cancel-bank-receipt-payment",
                type: "POST",
                headers: this.ajxHeaders,
                data:{
                    id:ids,
                    bank_rec_id:self.selId,
                    flag:flag,
                    is_returned:self.returnedTrans
                },
                dataType: "json",
                success: function (data) {
                    self.loadingModal = false;
                    self.loadOnce = 0;
                    console.log(data);
                    if (data.code == 201){
                        self.loadReceiptItem();
                        self.mapperIdArr = [];
                        self.$swal('',data.message,'info');
                        return;
                    }
                    if (data.status == "success") {

                        self.idArr = [];
                        self.invidArr = [];
                        if (flag == 'deposit'){
                            if (self.invrows && self.invrows.length){
                                for(var i=0;i<self.invrows.length;i++){
                                    $("#cancelCheckbox"+i).prop('checked',false);
                                }
                            }
                            self.invoiceIds = [];
                            self.getInvoices('');
                        }
                        console.log("LOAD == 2");
                        self.loadReceiptItem();
                        self.mapperIdArr = [];
                        // if (data.bank && self.$route.params.id == undefined){
                        //     self.bank_code = data.bank;
                        // }
                    }
                    if (flag == 'deposit'){
                        if (data.subsystem != undefined && data.subsystem != null) {
                            if (data.subsystem != "") {
                                self.$swal('',data.subsystem,'info');
                            }
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loadOnce = 0;
                    self.loadingModal = false;
                    self.generateStatusCodeMessage(jqXHR,false,'cancel_receipt_payment')
                }
            });

        },
        grossInvoice: function(invoiceId,currentOpenInvAmt,flag = ''){
            var self = this;
            if (flag != '' && flag == 'multiple'){
                invoiceId = self.invoiceIds;
                 if (self.invoiceIds.length){
                    for(var i =0;i<self.invoiceIds.length; i++){
                        if (self.invoiceIds[i].open_amount != undefined && self.invoiceIds[i].inv_amount != undefined){
                            if (self.invoiceIds[i].open_amount == 0){
                                self.$swal('','Some invoices already mapped','info');
                                return;
                            }
                        }
                    }
                }
            }else{
                if (currentOpenInvAmt > self.difference) {
                    self.$swal('','Open Amount cannot be greater than PMT Amount.','info');
                    return;
                }
            }
            self.showFullAndCustom = false;
            self.loadingModal = true;
            // }else{
            $.ajax({
                url: process.env.ROOT_API + "/map-bank-invoice-receipt",
                type: "POST",
                headers: this.ajxHeaders,
                data:{
                    invoice_id:invoiceId,
                    receipt_item_id:self.selId,
                    flag:flag,
                    tr_type:self.transaction_type.value,
                    is_returned : self.returnedTrans
                },
                dataType: "json",
                success: function (data) {
                    self.loadingModal = false;
                    self.showFullAndCustom = true;
                    console.log(data);
                    self.trTypeDisable = true;
                    $('#fullMap').removeClass('hide');
                    if (data.status == "success") {
                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                        }
                        // self.amount_applied += data.content.application_amount;
                        if (flag == 'multiple' || self.partialMatch){
                            // $("#cancelCheckbox").prop('checked',false);
                            self.invoiceIds = [];
                            if (self.invrows && self.invrows.length){
                                for(var i=0;i<self.invrows.length;i++){
                                    $("#cancelCheckbox"+i).prop('checked',false);
                                }
                            }
                            self.mapperIdArr = [];

                            self.getInvoices('');
                        }else{
                          console.log("LOAD == 3");
                            self.loadReceiptItem();
                            // self.fetchOpenInvoices(self.selId,'Deposit');
                            self.settlement();
                        }
                        self.$swal('','Item successfully mapped','success');
                    }
                },
                error: function (jqXHR, exception) {
                    $('#fullMap').removeClass('hide');
                    self.loadingModal = false;
                    self.showFullAndCustom = true;
                    self.generateStatusCodeMessage(jqXHR,false,'gross-invoice-map-bank')
                }
            });
            // }

        },
        mapSpecificInvoiceReceipt:function(){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            var error = false;
            self.common_error_msg = "";
            self.application_amount_error = '';

            if (self.creditrows && self.creditrows.length && self.onSecurityDeposit){
                self.onSecurityDepositStore();
                // noNeedSp = true;
                return;
            }
            if (self.accrows && self.accrows.length && self.onAccount){
                self.onAccountMap();
                noNeedSp = true;
                return;
            }

            if (self.cashrows && self.cashrows.length && self.onCash){
                self.onCashMap();
                noNeedSp = true;
                return;
            }

            if ((self.application_amount == 0 || self.application_amount == '') && (self.discount_amount == 0 || self.discount_amount == '') && (self.acc_amount == 0 || self.acc_amount == '')){
                self.application_amount_error = 'Amount is required';
                error = true;
            }

            // if ((Number(self.application_amount) > self.current_open_amount) || (Number(self.application_amount) > self.open_amount)) {
            //     self.common_error_msg = "Application Amount cannot be greater than Invoice Open Amount and Receipt Open Amount.";
            //     error = true;
            // }

            if (self.application_amount > self.difference) {
                self.$swal('','Open Amount cannot be greater than PMT Amount.','info');
                error = true;
            }

            if (!error) {

                var fields = $("#bankRecMapper").serializeArray();

                fields.push({
                    name: "bank_rec_id",
                    value: self.selId
                });

                fields.push({
                        name: "invoice_id",
                        value: self.spc_invoice_id
                    });

                fields.push({
                        name: "application_amount",
                        value: self.application_amount
                    });

                fields.push({
                        name: "open_amount",
                        value: self.open_amount
                    });

                fields.push({
                        name: "discount_amount",
                        value: self.discount_amount
                    });

                fields.push({
                        name: "gl_account_id",
                        value: self.gl_account_id.value
                    });

                fields.push({
                        name: "accomodation_amount",
                        value: self.acc_amount
                    });

                fields.push({
                        name: "late_fee_gl_account_id",
                        value: self.late_fee_gl_account_id.value
                    });

                fields.push({
                        name: "late_fee",
                        value: self.late_fee
                    });

                fields.push({
                    name: "tr_type",
                    value: self.transaction_type.value
                });

            var noNeedSp = false;

            if (!self.specificInvoice){
                return;
            }
            $('#mySpecificButton').prop('disabled',true);
            $.ajax({
                url: process.env.ROOT_API + "/map-sp-bank-receipt",
                type: "POST",
                headers: this.ajxHeaders,
                data:fields,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    $('#mySpecificButton').prop('disabled',false);
                    self.trTypeDisable = true;
                    console.log(data);
                    if (data.status == "success") {
                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                        }
                        // self.amount_applied += data.content.application_amount;
                        if (self.specificInvoice){

                            self.specificInvoice = false;
                            self.application_amount = 0.00;
                            self.open_amount = 0.00;
                            self.discount_available = 0.00;
                            self.acc_amount = 0.00;
                            self.discount_amount = 0.00;
                            self.gl_account_id = '';
                            // self.calculateAmount();
                            // self.getInvoices();
                            console.log("LOAD == 4");
                            self.loadReceiptItem();
                            self.fetchOpenInvoices(self.selId,'Deposit');
                            self.settlement();
                            // $('.purchase-order-create-main').show();
                        }else{
                            self.onAccount = false;
                            self.accrows = [];
                            // self.getMappedItems('account');
                        }
                        self.$swal('','Item successfully mapped','success');
                    }
                },
                error: function (jqXHR, exception) {
                    $('#mySpecificButton').prop('disabled',false);
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'map-specific-receipt-bank')
                }
            });

        }

    },

    onCashMap: function(){
        var self = this;

        var fields = $("#bankRecMapper").serializeArray();
        self.disError = false;
        var amount = 0;
        var error = false;

        for (var i = 0; i < self.cashrows.length; i++) {
                    // console.log(self.rows[i]);
            self.cashrows[i].account_error_msg = "";
            self.cashrows[i].amount_error_msg = "";


            if (self.cashrows[i].gl_account_id == null || !self.cashrows[i].gl_account_id.value) {
                self.cashrows[i].account_error_msg = "GL Account is Required.";
                 error = true;
            }
            if (self.cashrows[i].amount == null || !self.cashrows[i].amount) {
                self.cashrows[i].amount_error_msg = "Amount is Required.";
                 error = true;
            }

            if (self.cashrows[i].mapper_id && self.cashrows[i].mapper_id > 0){

            }else{

                amount += parseFloat(self.cashrows[i].amount);
                amount += parseFloat(self.cashrows[i].tax);

            }
        }


        if (amount > self.difference){
            self.$swal('','Amount should not be greater than Remaining PMT Amount' ,'info');
            error = true;
        }

        fields.push({
            name: "bank_rec_id",
            value: self.selId
        });

        fields.push({
            name: "returned",
            value: self.returnedTrans
        });

        fields.push({
                name: "on_cash_item",
                value: JSON.stringify(self.cashrows)
            });

        fields.push({
            name: "tr_type",
            value: self.transaction_type.value
        });

        if ( !error){
            self.loadingModal = true;
            $.ajax({
                url: process.env.ROOT_API + "/map-oncash-bank-receipt",
                type: "POST",
                headers: this.ajxHeaders,
                data:fields,
                dataType: "json",
                success: function (data) {
                   self.loadingModal = false;
                    console.log(data);
                    if (data.code == 201){
                        self.$swal('',data.message,'info');
                        return;
                    }
                    self.trTypeDisable = true;
                    if (data.status == "success") {

                        // self.onCash = false;
                        self.cashrows = [];
                        // if(data.content.application_amount){
                        //     self.amount_applied += data.content.application_amount;

                        //     self.calculateAmount();
                        // }
                        // if (self.difference > 0){
                            // if (self.$route.params.id == undefined){
                            //     self.$router.push('/receipt-invoice/map/'+self.receiptPayment.value);
                            // }
                            console.log("LOAD == 5");
                            self.loadReceiptItem();
                            self.settlement();
                        // }else{
                        //     self.$router.push('/payment-receipt/list');
                        // }
                        // self.getMappedItems('cash');

                        self.$swal('','Item successfully mapped','success');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loadingModal = false;
                    self.generateStatusCodeMessage(jqXHR,false,'map-on-cash-receipt')
                }
            });
        }
    },
    onAccountMap: function(){
        var self = this;
        self.disError = false;
        var amount = 0;
        var error = false;
        for (var i = 0; i < self.accrows.length; i++) {
                    // console.log(self.rows[i]);
            self.accrows[i].customer_error_msg = "";
            self.accrows[i].amount_error_msg = "";


            if (self.accrows[i].acc_customer_id == null || !self.accrows[i].acc_customer_id.value) {
                self.accrows[i].customer_error_msg = "Customer is Required.";
                error = true;
            }
            if (self.accrows[i].amount == null || !self.accrows[i].amount) {
                self.accrows[i].amount_error_msg = "Amount is Required.";
                error = true;
            }
            if (self.accrows[i].mapper_id && self.accrows[i].mapper_id > 0){

            }else{

                amount += parseFloat(self.accrows[i].amount);

            }
        }

        // TODO:MYR
        if (self.accrows && self.accrows.length && parseFloat(amount) > parseFloat(self.difference)) {
            self.$swal('','Amount should not be greater than Remaining PMT Amount','info');
            error = true;
        }

        if (error === true){
            return;
        }

        var fields = $("#bankRecMapper").serializeArray();

        fields.push({
            name: "bank_rec_id",
            value: self.selId
        });

        fields.push({
            name: "returned",
            value: self.returnedTrans
        });
        // fields.append(
        //     "returned",
        //     self.returnedTrans
        // );
        fields.push({
                name: "on_account_item",
                value: JSON.stringify(self.accrows)
            });

        fields.push({
            name: "tr_type",
            value: self.transaction_type.value
        });

        self.loadingModal = true;
        $.ajax({
            url: process.env.ROOT_API + "/map-onaccount-bank-receipt",
            type: "POST",
            headers: this.ajxHeaders,
            data:fields,
            dataType: "json",
            success: function (data) {
                self.loadingModal = false;
                console.log(data);
                if (data.code == 201){
                    self.$swal('',data.content,'info');
                    return;
                }
                self.trTypeDisable = true;
                if (data.status == "success") {

                    // self.onAccount = false;
                    self.accrows = [];
                    if(data.content.application_amount){
                        self.amount_applied += data.content.application_amount;

                        // self.calculateAmount();
                    }
                    // if (self.difference > 0){
                        // if (self.$route.params.id == undefined){
                        //     self.$router.push('/receipt-invoice/map/'+self.receiptPayment.value);
                        // }
                        console.log("LOAD == 6");
                        self.loadReceiptItem();
                        self.settlement();
                    // }else{
                    //     self.$router.push('/payment-receipt/list');
                    // }
                    // self.getMappedItems('cash');
                    self.$swal('','Item successfully mapped','success');
                }
            },
            error: function (jqXHR, exception) {
                self.loadingModal = false;
                self.generateStatusCodeMessage(jqXHR,false,'map-on-account-receipt')
            }
        });

    },
    onSecurityDepositStore: function(){
        var self = this;

        const fields = new FormData();
        // var fields = $("#bankRecMapper").serializeArray();

        fields.append('items',JSON.stringify($("#bankRecMapper").serializeArray()));
        self.disError = false;
        var amount = 0;
        var error = false;

        for (var i = 0; i < self.creditrows.length; i++) {
                    // console.log(self.rows[i]);
            self.creditrows[i].customer_error_msg = "";
            self.creditrows[i].amount_error_msg = "";
            self.creditrows[i].description_error_msg = "";


            if (self.creditrows[i].customer_id == null || !self.creditrows[i].customer_id.value) {
                self.creditrows[i].customer_error_msg = "Customer is Required.";
                 error = true;
            }
            if (self.creditrows[i].amount == null || !self.creditrows[i].amount) {
                self.creditrows[i].amount_error_msg = "Amount is Required.";
                 error = true;
            }
            if(!self.isUnit) {
              if (self.creditrows[i].description == null || self.creditrows[i].description == "") {
                  self.creditrows[i].description_error_msg = "Description is Required.";
                  error = true;
              }
            }

            if (self.creditrows[i].mapper_id && self.creditrows[i].mapper_id > 0){

            }else{

                amount += parseFloat(self.creditrows[i].amount);

            }
        }


        if (amount > self.difference){
            self.$swal('','Amount should not be greater than Remaining PMT Amount' ,'info');
            error = true;
        }

        // if (validateUpdate == 1 && validateRequired == 1) {

        //     if (!self.dropZonePreviewFiles.length && !self.docArr.length ){
        //         self.fileerror_msg = 'File Required';
        //         error = true;
        //     }
        // }
        // alert(self.docArr.length);

        if (self.docArr.length > 0) {
            if (self.validateDocs.length > 0) {
                for (var i = 0;i < self.validateDocs.length;i++) {
                    let fileObj = self.validateDocs[i];

                    if (fileObj.extension != undefined) {
                        if (fileObj.extension == "jpeg" || fileObj.extension == "png" || fileObj.extension == "jpg" || fileObj.extension == "pdf" || fileObj.extension == "doc" || fileObj.extension == "docx") {

                        }else{
                            self.fileerror_msg = "Only Images or PDF or Doc Files Are Allowed (.jpg / .jpeg / .png / .pdf / .doc / .docx).";
                            error = true;
                        }
                    }

                    if (fileObj.size != undefined) {
                        if(fileObj.size > 5000000){
                            self.fileerror_msg = "File Size Should Not Be Greater Than 5 MB.";
                            error = true;
                        }
                    }
                }
            }
        }

        fields.append(
                    "bank_rec_id",
                    self.selId
                );
        fields.append(
            "returned",
            self.returnedTrans
        );
        fields.append(
            "docArr",
            JSON.stringify(self.docArr)
        );
        // fields.push({
        //    name: "docArr",
        //     value:JSON.stringify(self.docArr)
        // });

        fields.append(
            "deposit_item",
            JSON.stringify(self.creditrows)
        );

        fields.append(
            "tr_type",
            self.transaction_type.value
        );
        // fields.push({
        //         name: "deposit_item",
        //         value: JSON.stringify(self.creditrows)
        //     });

            if ( !error){
                self.loadingModal = true;
                $.ajax({
                    url: process.env.ROOT_API + "/security-deposit-bank-receipt",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data:fields,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loadingModal = false;
                        console.log(data);
                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                        }
                        self.trTypeDisable = true;
                        if (data.status == "success") {

                            // self.onSecurityDeposit = false;
                            self.creditrows = [];
                            // if(data.content.application_amount){
                            //     self.amount_applied += data.content.application_amount;

                            //     self.calculateAmount();
                            // }
                            // if (self.difference > 0){
                                // if (self.$route.params.id == undefined){
                                //     self.$router.push('/receipt-invoice/map/'+self.receiptPayment.value);
                                // }
                                console.log("LOAD == 7");
                                self.loadReceiptItem();
                                self.settlement();
                            // }else{
                                // self.$router.push('/payment-receipt/list');
                            // }
                            // self.getMappedItems('cash');
                            self.$swal('','Item successfully mapped','success');
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loadingModal = false;
                        self.generateStatusCodeMessage(jqXHR,false,'security-deposit-bank-receipt')
                    }
                });
            }
        },
        loadReceiptItem() {

            var self = this;
            self.loadingModal = true;
            self.disError = false;
            $.ajax({
                url: process.env.ROOT_API + "/one-bank-receipt-item/" + self.selId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loadingModal = false;
                    if (data.status == "success") {
                        self.adjustButton = false;
                        self.securityview = [];
                        self.onaccountView = [];
                        self.directglView = [];
                        self.mapperIdArr = [];
                        self.mappedVoucher = [];
                        self.mappedAL = [];
                        // self.payment_number = data.content.payment_number;
                        // self.payment_date = data.content.payment_date;
                        // self.bank_code = data.content.bank_code;
                        // self.payment_currency_code = data.content.payment_currency_code;
                        // self.payment_type =  data.content.type;
                        self.payment_amount = data.content.amount;
                        self.difference = data.content.balance;
                        self.amount_applied = data.content.applied_amount;
                        if (data.content.customer_id != undefined && data.content.customer_id != null){
                            self.existingCustomer = {text:data.content.custCode+' | '+data.content.custName,value:data.content.customer_id}
                        }
                        if ( data.content.invoices.mapped_invoice){
                            // self.invoice_id = data.content.invoices.invoice;
                            // self.getInvoices();
                            self.mappedInvoices = data.content.invoices.mapped_invoice;
                        }else{
                            self.mappedInvoices = [];
                        }

                        if ( data.content.invoices.mapped_payment){
                            // self.invoice_id = data.content.invoices.invoice;
                            // self.getInvoices();
                            self.mappedPayments = data.content.invoices.mapped_payment;
                        }else{
                            self.mappedPayments = [];
                        }


                        // if ( data.content.invoices.cust){
                        //     self.customer_id = data.content.invoices.cust;

                        // }
                         if ( data.content.invoices.all){
                            // self.invoice_id = data.content.invoices.invoice;
                            // self.getInvoices();
                            self.allMapped = data.content.invoices.all;
                        }else{
                            self.allMapped = [];
                        }
                        if ( data.content.invoices.bdgl != undefined){
                            // self.invoice_id = data.content.invoices.invoice;
                            // self.getInvoices();
                            self.bdglView = data.content.invoices.bdgl;
                        }else{
                            self.bdglView = [];
                        }

                        if ( data.content.invoices.refund != undefined){
                            // self.invoice_id = data.content.invoices.invoice;
                            // self.getInvoices();
                            self.refundView = data.content.invoices.refund;
                        }else{
                            self.refundView = [];
                        }

                        if ( data.content.invoices.customer){
                            var cust = data.content.invoices.customer;
                            self.accrows = [];
                            for (var n = 0; n < cust.length; n++){
                                self.accrows.push({
                                    mapper_id: cust[n].id,
                                    acc_customer_id: cust[n].customer_id != null ? {text:cust[n].customer,value:cust[n].customer_id} : '',
                                    customer_error_msg: "",
                                    description: cust[n].description,
                                    amount: cust[n].amount,
                                    amount_error_msg:'',
                                    is_disable:cust[n].is_disable,
                                    is_cancelled:cust[n].is_cancelled != undefined ? cust[n].is_cancelled : 'no',
                                });
                            }
                            self.custDisabled = true;
                            // self.onAccount = true;
                            var amount = 0;
                            // var accomodation_amount = 0;

                            // if (cust.amount){

                            //     amount = cust.amount;
                            // }

                            // self.amount_applied += amount;
                        }else{
                            self.accrows = [];
                        }
                        if ( data.content.invoices.customerview){
                            var custview = data.content.invoices.customerview;
                            self.onaccountView = [];
                            for (var l = 0; l < custview.length; l++){
                                self.onaccountView.push({
                                    mapper_id: custview[l].id,
                                    acc_customer_id: custview[l].customer_id != null ? {text:custview[l].customer,value:custview[l].customer_id} : '',
                                    customer_error_msg: "",
                                    description: custview[l].description,
                                    amount: custview[l].amount,
                                    amount_error_msg:'',
                                    is_cancelled:custview[l].is_cancelled != undefined ? custview[l].is_cancelled : 'no',
                                });
                            }
                        }else{
                            self.onaccountView = [];
                        }
                        if (data.content.invoices.security){
                            var custsec = data.content.invoices.security;
                            self.glOfSecurity = {text:custsec[0].gl,value:custsec[0].gl_account_id};
                            self.creditrows = [];
                            for (var k = 0; k < custsec.length; k++){
                                self.creditrows.push({
                                    mapper_id: custsec[k].id,
                                    gl_account_id: {text:custsec[k].gl,value:custsec[k].gl_account_id},
                                    customer_id: custsec[k].customer_id != null ? {text:custsec[k].customer,value:custsec[k].customer_id}:'',
                                    customer_error_msg: "",
                                    vehicle_id: (custsec[k].vehicle_id && custsec[k].vehicle_id != null) ? {text:custsec[k].vehicle,value:custsec[k].vehicle_id} : '',
                                    amount: custsec[k].amount,
                                    amount_error_msg:'',
                                    description:custsec[k].description,
                                    description_error_msg:'',
                                    is_disable:custsec[k].is_disable,
                                    is_cancelled:custsec[k].is_cancelled != undefined ? custsec[k].is_cancelled : 'no',
                                });
                            }
                            if (data.content.invoices.docs != null && data.content.invoices.docs != undefined ){
                                self.dropZonePreviewFiles = data.content.invoices.docs;
                                self.loadFilesPreview();
                            }else{
                                self.docArr = [];
                                self.validateDocs = [];
                                self.filesArr = [];
                            }
                            // self.custDisabled = true;
                            // self.onAccount = true;
                            var amount = 0;
                            // self.onSecurityDeposit = true;
                        }else{
                            self.creditrows = [];
                        }

                        if (data.content.invoices.securityview){
                            var custsecview = data.content.invoices.securityview;
                            self.securityview = [];
                            for (var j = 0; j < custsecview.length; j++){
                                self.securityview.push({
                                    mapper_id: custsecview[j].id,
                                    gl_account_id: {text:custsecview[j].gl,value:custsecview[j].gl_account_id},
                                    customer_id: custsecview[j].customer_id != null ? {text:custsecview[j].customer,value:custsecview[j].customer_id}:'',
                                    customer_error_msg: "",
                                    vehicle_id: (custsecview[j].vehicle_id && custsecview[j].vehicle_id != null) ? {text:custsecview[j].vehicle,value:custsecview[j].vehicle_id} : '',
                                    amount: custsecview[j].amount,
                                    amount_error_msg:'',
                                    description:custsecview[j].description,
                                    is_cancelled:custsecview[j].is_cancelled != undefined ? custsecview[j].is_cancelled : 'no',
                                });
                            }
                            // self.custDisabled = true;
                            // self.onAccount = true;
                            var amount = 0;
                            // self.onSecurityDeposit = true;
                        }else{
                            self.securityview = [];
                        }
                        if ( data.content.invoices.gl){
                            var gl = data.content.invoices.gl;
                            if (gl.length > 0){
                                self.cashrows = [];
                                // self.onCash = true;
                                for (var i = 0; i < gl.length; i++){
                                    self.cashrows.push({
                                        mapper_id: gl[i].id,
                                        gl_account_id: gl[i].gl_account_id != null ? {text:gl[i].gl_account,value:gl[i].gl_account_id} : '',
                                        account_error_msg: "",
                                        description: gl[i].description,
                                        amount: gl[i].amount,
                                        amount_error_msg:'',
                                        tax:gl[i].tax,
                                        is_cancelled:gl[i].is_cancelled != undefined ? gl[i].is_cancelled : 'no',
                                    });
                                }
                            }
                            self.glDisabled = true;
                        }else{
                            self.cashrows = [];
                        }
                        if ( data.content.invoices.glview){
                            var glview = data.content.invoices.glview;
                            if (glview.length > 0){
                                self.directglView = [];
                                // self.onCash = true;
                                for (var i = 0; i < glview.length; i++){
                                    self.directglView.push({
                                        mapper_id: glview[i].id,
                                        gl_account_id: glview[i].gl_account_id != null ? {text:glview[i].gl_account,value:glview[i].gl_account_id} : '',
                                        account_error_msg: "",
                                        description: glview[i].description,
                                        amount: glview[i].amount,
                                        amount_error_msg:'',
                                        tax:glview[i].tax,
                                        is_cancelled:glview[i].is_cancelled != undefined ? glview[i].is_cancelled : 'no',
                                    });
                                }
                            }
                        }else{
                            self.directglView = [];
                        }

                        if ( data.content.invoices.voucher){
                            self.mappedVoucher = data.content.invoices.voucher;
                        }else{
                            self.mappedVoucher = [];
                        }

                        if ( data.content.invoices.al){
                            self.mappedAL = data.content.invoices.al;
                        }else{
                            self.mappedAL = [];
                        }

                        self.expchartData = {
                            labels: ['PMT Amount - '+self.currencyFormat(self.payment_amount) ,'Applied Amount - '+self.currencyFormat(self.amount_applied),'Difference - '+self.currencyFormat(self.difference)],
                            datasets: [
                                {
                                    label:'PMT Amount',
                                    borderWidth: 1,
                                    borderColor: ["cyan","yellow","red"],
                                    backgroundColor:["cyan","yellow","red"],
                                    data:[self.payment_amount,self.amount_applied,self.difference]
                                },
                                // {
                                //     label:'Applied Amount',
                                //     borderWidth: 1,
                                //     borderColor:"rgba(71, 183,132,.5)",
                                //     backgroundColor:"#47b784",
                                //     data:[self.amount_applied]
                                // },
                                //  {
                                //     label:'Difference',
                                //     borderWidth: 1,
                                //     borderColor:"rgba(71, 183,132,.6)",
                                //     backgroundColor:"#47b785",
                                //     data:[self.difference]
                                // },
                            ]
                        };
                        // self.calculateAmount();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loadingModal = false;
                    self.generateStatusCodeMessage(jqXHR,true,'one-bank-receipt-transfer-item');
                }
            });
        },
        loadFilesPreview:function() {
            var self = this;
            self.docArr = [];
            self.validateDocs = [];
            if ( self.dropZonePreviewFiles.length > 0 ) {
                for ( var i = 0;i<self.dropZonePreviewFiles.length;i++ ) {
                    var url = self.dropZonePreviewFiles[i].url;
                    //get file path from url
                    self.docArr.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
                    self.validateDocs.push({
                        file_name:self.dropZonePreviewFiles[i].display_name,
                        extension:self.dropZonePreviewFiles[i].ext
                    });
                }
            }
        },
        getFilePathFromUrl (value) {

            var path = "";
            var src = value.split('/');
            var file_name = src[src.length - 1];
            var orgPath = src[src.length - 2];
            path = orgPath + "/" + file_name;
            return path;

        },
        spInvoice:function(evt , id,currentOpenInvAmt){
            var self = this;

            self.spc_invoice_id = id;
            // self.application_amount = self.difference;
            self.application_amount = currentOpenInvAmt;
            self.open_amount = self.difference;
            self.current_open_amount = currentOpenInvAmt;
            self.specificInvoice = true;

           setTimeout(function(){
                    let scroll_to_bottom = document.getElementById('scroll-to-bottom');

                $('#myBankModal').animate({
                    scrollTop: $(".cover").offset().top + scroll_to_bottom.scrollHeight
                }, 500);

            },300);
        },
        openModal: function(){
            var self = this;
            console.log(self.selectedFile);
            self.selectedFile = "";
            self.importerror = '';
            self.duplicateTransfer = [];
            self.lockbox = false;
            self.rod = false;
            self.ach = false;
            self.sequenceArr = [];
            $("#typeImage").val('');
            $('#myModal').modal('show');
        },
        settlement:function(){
            var self = this;
            self.alreadyMapped = true;
            self.specificInvoice = false;
            self.onAccount = false;
            self.onCash = false;
            self.findARGLMatch = false;
            self.onSecurityDeposit = false;
            self.disError = false;
            self.partialMatch = false;
            self.invoiceIds = [];
            self.apPaymentIds = [];
            self.customer_id = '';
            self.partialAPMatch = false;
            self.findGLMatch = false;
            self.glMapData = [];
            setTimeout(function(){
                $("#rbsettlementacct").click();
            },1000);
        },
        checkPartialMapping:function(evt){
            var self = this;
            self.alreadyMapped = false;
            self.custExist = false;
            self.findARGLMatch = false;
            self.specificInvoice = false;
            self.onAccount = false;
            self.onCash = false;
            self.onSecurityDeposit = false;
            self.disError = false;
            self.onSettlementAccount = false;
            self.partialMatch = true;
            self.invData = [];
            self.mapperIdArr = [];
            self.disError = false;
            self.notFoundMsg = '';
            self.totalSelectedInvAmount = 0;
            if (self.existingCustomer != ''){
                self.customer_id = self.existingCustomer;
                self.custExist = true;
            }
        },
        getInvoices: function(from){
            var self = this;
            var invArr = [];
            var customer_id = 0;

            if ( self.customer_id != null && self.customer_id.parent_id ){
                customer_id = self.customer_id.parent_id;
            }
            if (self.invoice_ids.length > 0){
                invArr = self.invoice_ids;
            }

            self.loadingModal = true;
            $.ajax({
                url: process.env.ROOT_API + "/get-bank-rec-invoices",
                type: "GET",
                headers: this.ajxHeaders,
                data:{
                    customer_id:customer_id,
                    rec_id:self.selId,
                    invoices:invArr,
                    from:from
                },
                dataType: "json",
                success: function (data) {
                    self.loadingModal = false;
                    if (data.status == "success") {
                        self.invrows = data.content.inv;
                        if (data.content.dis){
                            var disObj = data.content.dis[0].discount_id;

                            if (disObj > 0){
                                self.discountId = disObj;
                            }else{
                                self.discountId = 0;
                            }
                        }
                        console.log("LOAD == 8");
                        self.loadReceiptItem();
                            // $("input:checkbox").prop('checked',false);
                    //    self.calculateAmount();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loadingModal = false;
                    self.generateStatusCodeMessage(jqXHR,true,'customer-invoice-items');
                }
            });
        },
        viewDiscount:function(){
            var self = this;

            // self.$router.push('/discount-customer/view/'+self.discountId);
            var url = '&id='+self.selId+'&redirectFrom=bank';
            let routeData = self.$router.resolve({name: 'DiscountCustomerList', params: {id: self.discountId},query: { data : btoa(url) }});
            window.open(routeData.href, '_blank');
        },
        // clickRows(evt,id,open_amount){
        //     var self = this;
        //     // alert(id);
        //     // if (id == 0){
        //     //     self.$swal('','You can only cancel Applied invoice','info');
        //     //     evt.target.checked = false;
        //     //     return;
        //     // }
        //     console.log(evt.target.checked);
        //     if(evt.target.checked == true){
        //         self.invidArr.push({id:id});
        //     }else{
        //         var i = self.invidArr.indexOf(id);
        //         const filteredItems = self.invidArr.filter(function(item) {
        //             return item.id !== id
        //         })
        //         self.invidArr = filteredItems;
        //     }
        //     console.log(self.invidArr);
        // },
        clickRows:function(evt,rcId,invid,amountSelected,invAmt,from){
            var self = this;
            // var rcId = $(evt.target).attr("data-id");
            // var rcId = evt.target.value;
            if (from == 'settle_screen'){
                if (confirm('Are you sure that you want to cancel this settlement? ')) {
                    if (rcId != undefined){
                        self.mapperIdArr.push({id:rcId,open_amount:amountSelected,inv_amount:invAmt});
                        self.cancelReceiptPayment('settle');
                    }
                }
            }else{
                if(evt.target.checked == true){

                    self.totalSelectedInvAmount += amountSelected;
                    if (self.totalSelectedInvAmount > self.difference){
                        self.$swal('','Selected invoice amount is greater than remaining payment amount','info');
                        evt.target.checked = false;
                        self.totalSelectedInvAmount -= amountSelected;
                        return;
                    }
                    self.invoiceIds.push({id:invid,open_amount:amountSelected,inv_amount:invAmt});
                    //another array for already mapped records to cancel
                    if (rcId != undefined){
                        self.mapperIdArr.push({id:rcId,open_amount:amountSelected,inv_amount:invAmt});
                    }
                }else{

                    self.totalSelectedInvAmount -= amountSelected;
                    var i = self.invoiceIds.indexOf(invid);
                    const filteredItems = self.invoiceIds.filter(function(item) {
                        return item.id !== invid
                    })
                    self.invoiceIds = filteredItems;

                    var j = self.mapperIdArr.indexOf(rcId);
                    const filteredMapItems = self.mapperIdArr.filter(function(item) {
                        return item.id !== rcId
                    })
                    self.mapperIdArr = filteredMapItems;
                }
                console.log(self.invoiceIds);

            }

            console.log(self.mapperIdArr);
        },
        selectAccountLedger:function(evt,id,amount){
            var self = this;
            if(evt.target.checked == true){
                self.totalSelectedGlAmount += amount;
                if (self.totalSelectedGlAmount > self.difference){
                    self.$swal('','Selected gl amount is greater than remaining payment amount','info');
                    evt.target.checked = false;
                    self.totalSelectedGlAmount -= amount;
                    return;
                }
                self.selectedGLArr.push({id:id,inv_amount:amount});
            }else{

                self.totalSelectedGlAmount -= amount;
                var i = self.selectedGLArr.indexOf(id);
                const filteredItems = self.selectedGLArr.filter(function(item) {
                    return item.id !== id
                })
                self.selectedGLArr = filteredItems;
            }
            console.log(self.selectedGLArr);
        },
        clickAPRows:function(){
            var self = this;
            var rcId,invid,amountSelected,invAmt,from;
            var rowData = self.$refs['listVoucherTable'].selectedRows;
            console.log(rowData);
            self.voucherIds = [];
            if (rowData.length != undefined){
                self.totalSelectedVoucherAmount = 0;
                for(var i=0;i<rowData.length;i++){
                    self.totalSelectedVoucherAmount += rowData[i].total;
                    if (self.totalSelectedVoucherAmount > self.difference){
                        self.$swal('','Selected voucher amount is greater than remaining payment amount','info');
                        // EventBus.$emit('clear-selection', false);
                        self.$refs['listVoucherTable'].unselectAllInternal();
                        self.totalSelectedVoucherAmount -= amountSelected;
                        return;
                    }else{
                        self.voucherIds.push({id:rowData[i].bill_id,open_amount:rowData[i].total});
                    }
                }
            }
        },
        clickAPPaymentRows:function(){
            var self = this;
            var amountSelected;
            var rowData = self.$refs['listPaymentTable'].selectedRows;
            self.apPaymentIds = [];
            if (rowData.length != undefined){
                self.totalSelectedVoucherAmount = 0;
                for(var i=0;i<rowData.length;i++){
                    self.totalSelectedVoucherAmount += rowData[i].total;
                    if (self.totalSelectedVoucherAmount > self.difference){
                        self.$swal('','Selected vendor payment amount is greater than remaining receipt amount','info');
                        self.$refs['listPaymentTable'].unselectAllInternal();
                        self.totalSelectedVoucherAmount -= amountSelected;
                        return;
                    }else{
                        self.apPaymentIds.push({id:rowData[i].payment_id,open_amount:rowData[i].total});
                    }
                }
            }
        },
        resetAll:function(){
            var self = this;

            $(".clickable").removeClass('adjustColor');
            self.loadList('cancel');
            // if ($("#expanded-row-"+self.selId) {
                // if ($("#expanded-row-"+self.selId).prevSibling != null) {
            setTimeout(function(){
                var link  = $("#row-id-"+self.parentId);
                link.click();
                link.click();
            },200);

            self.vendor_id = '';
            self.voucherIds = [];
            self.voucherrows = [];
            self.paymentRows = [];
            self.al_id = '';
            self.jvArr = [];
            self.voucherIds = [];
            self.voucherArr = [];
            self.vendorArr = [];
            self.routeSelId = '';

        },
        bankTransferDetail(params) {
            var self = this;
            $("#myBankModal").modal('show');
            self.selId = params.row.id;
            self.type = params.row.type;
            self.amount = params.row.amount;
            self.description = params.row.description;
            self.account_no = params.row.account_number;
            self.account_name = params.row.account_name;
            self.date = params.row.date;
            self.difference = params.row.ori_amount;
            self.notFoundMsg = '';
            self.glOfSecurity = {};
            self.customer_id = '';
            self.customerArr = [];
            self.invoiceIds = [];
            self.partialMatch = false;
            self.invrows = [];
            self.mappedInvoices = [];
            self.mappedPayments = [];

            $(".findmatch").prop('checked', false);

            setTimeout(function(){
                if (self.type != 'Deposit' && self.type != 'Ach' && self.type != 'Lockbox' && self.type != 'Remote Online Deposit' && self.type != 'Return' && self.type != 'Adj'){
                    $("#rbsettlementacctp").click();
                }else{
                    $("#rbsettlementacct").click();
                    console.log("LOAD == 9");
                    self.loadReceiptItem();
                }
            },500);

            self.rowActivate = true;

            self.onCash = false;
            self.onSecurityDeposit=false;
            self.onAccount=false;
            self.specificInvoice = false;
            self.checkData = [];
            self.invData = [];
            // if (params.row.type == 'Check'){

            // }else if(params.row.type == 'Payment'){

            // }else{

            // }

            $( document ).ready(function() {
                // change div color to blue on page ready
                $(".mapReceiptModal").addClass('wo-vendorinv-form');
                $(".modal-backdrop").removeClass('show');
                $(".modal-backdrop").addClass('hide');
            });
        },
        adjustReceipt:function(){
            var self = this;
            // self.loading = true;

            self.$router.push('/receipt-adjustment/create');

        },

        addReceipt:function(){
            var self = this;
            self.$router.push('/payment-receipt/create');
        },
        setAmount: function(ind,flag){
            var self = this;

            if (self.type == 'Return'){
                if (flag == 'on_account'){
                    self.accrows[ind].amount = '-'+self.accrows[ind].amount;
                }
                if (flag == 'on_cash'){
                    self.cashrows[ind].amount = '-'+self.cashrows[ind].amount;
                }
                if (flag == 'on_deposit'){
                    self.creditrows[ind].amount = '-'+self.creditrows[ind].amount;
                }
            }

        },
        afterComplete(file,response){
            var self = this;
        },
        duplicateDocument(file){
            var self = this;
            console.log("file ==", file);

        },
        errorDocument(file,message,xhr){
            let response = xhr.response;
            let parse = JSON.parse(response, (key, value)=>{
            return value;
            });
            $('.dz-error-message span').text(parse.message);
        },
        storeDocument(file,response){
            var self = this;
            self.fileerror_msg = "";
            self.filesArr = [];
            self.docArr = [];
            self.validateDocs = [];
            var uploadResponse = response;

            //push doc path in doc array
            self.docArr.push(uploadResponse.content);
            self.filesArr.push(file);
            if (file.type != undefined) {
                var extension = file.type.split("/");
                self.validateDocs.push({
                    file_name:file.name,
                    size:file.size,
                    extension:extension[1]
                });
            }
        },
        checkIfClick:function(evt,flag){
            var self = this;
            if (evt.target.checked == true){
                if (flag == 'rod'){
                    self.lockbox = false;
                    self.ach = false;
                    $("#lockbox").prop('checked',false);
                    $("#ach").prop('checked',false);
                }else if (flag == 'ach'){
                    self.rod = false;
                    self.lockbox = false;
                    $("#lockbox").prop('checked',false);
                    $("#rod").prop('checked',false);
                }else{
                    self.rod = false;
                    self.ach = false;
                    $("#rod").prop('checked',false);
                    $("#ach").prop('checked',false);
                }
            }

        },
        removedSelectedFile(file, xhr, error) {
            var self = this;
            self.fileerror_msg = "";
            if (file.xhr != undefined) {
                var fileName = JSON.parse(file.xhr.response).content;

                var fileArr = fileName.split("/");

                self.removeFileFromServer(fileName,"temp",0);

                for(var i = 0;i<self.docArr.length;i++){
                    if ( self.docArr[i].includes(fileName)) {
                        self.docArr.splice(i,1);
                        self.validateDocs.splice(i,1);
                        self.filesArr.splice(i,1);
                    }
                }
            }
        },
        checkVoucher:function(evt){
            var self = this;

            self.partialAPMatch = true;
            self.findGLMatch = false;
            self.onSettlementAccount = false;
            self.checkData = [];
            self.invData = [];

        },
        checkARFindGL:function(evt){
            var self = this;
            self.findARGLMatch = true;
            self.findGLMatch = false;
            self.onSettlementAccount = false;
            self.onSecurityDeposit = false;
            self.onCash = false;
            self.onAccount = false;
            self.invData = [];
            self.specificInvoice = false;
            self.disError = false;
            self.partialMatch = false;
            self.application_amount_error = '';
            self.fetchGLWithSameAmount('');
        },
        checkFindGL:function(evt){
            var self = this;

            self.findGLMatch = true;
            self.partialAPMatch = false;
            self.findARGLMatch = false;
            self.onSettlementAccount = false;
            self.invData = [];
            self.voucherrows = [];
            self.paymentRows = [];
            // glMapData
            self.fetchGLWithSameAmount('');
        },
        fetchGLWithSameAmount:function(from){
            var self = this;
            var al_id = '';

            if (self.al_id == null){
                self.al_id = '';
                self.jvArr = [];
            }

            if (self.al_id != null && self.al_id.jv_number){
                al_id = self.al_id.jv_number;
            }else{
                if (from != ''){
                    return;
                }
            }

            self.loadingModal = true;
            $.ajax({
                url: process.env.ROOT_API + "/gl-amount/fetch",
                type: "POST",
                data: {
                    id:self.selId,
                    al_id:al_id
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.reqeustSent = 0;
                    self.loadingModal = false;
                    if ( data.code == 200 ) {
                        //check data records
                        self.partialAPMatch = false;
                        self.voucherrows = [];
                        self.paymentRows = [];
                        self.application_amount_error = '';
                        if ( data.content ) {
                            self.glMapData = data.content;
                        }
                    }else{
                        self.voucherrows = [];
                        self.paymentRows = [];
                        self.al_id = '';
                        self.jvArr = [];
                        self.checkData = [];
                        self.notFoundMsg = '';
                        self.disError = true;
                        self.glMapData = [];
                        self.notFoundMsg = 'No Data Found';
                    }
                },
                error: function (jqXHR, exception) {

                    self.reqeustSent = 0;

                    self.loadingModal = false;
                    self.generateStatusCodeMessage(jqXHR,true,'past-due-notice-details');
                }
            });
        },

        // getAL:function(){
        //     var self = this;
        //     var al_id = '';
        //     if (self.al_id != null && self.al_id.value){
        //         al_id = self.al_id.value;
        //     }else{
        //         return;
        //     }
        //     self.loadingModal = true;
        //     $.ajax({
        //         url: process.env.ROOT_API + "/gl-amount/fetch",
        //         type: "POST",
        //         data: {
        //             id:self.selId,
        //             al_id:al_id
        //         },
        //         headers: {
        //             "Accept": "application/json",
        //             "Authorization": "Bearer " + localStorage.getItem("tkn"),
        //             "Access-Control-Allow-Headers":
        //                 "Origin, Content-Type, Authorization,X-Requested-With",
        //             "Cache-Control": "no-cache"
        //         },
        //         dataType: "json",
        //         success: function (data) {

        //             self.reqeustSent = 0;
        //             self.loadingModal = false;
        //             if ( data.code == 200 ) {
        //                 //check data records
        //                 self.partialAPMatch = false;
        //                 self.voucherrows = [];
        //                 // self.application_amount_error = '';
        //                 if ( data.content ) {
        //                     self.glMapData = data.content;
        //                 }
        //             }else{
        //                 self.voucherrows = [];
        //                 self.checkData = [];
        //                 self.notFoundMsg = '';
        //                 self.al_id = '';
        //                 self.jvArr = [];
        //                 self.disError = true;
        //                 self.glMapData = [];
        //                 self.notFoundMsg = 'No Data Found';
        //             }
        //         },
        //         error: function (jqXHR, exception) {

        //             self.reqeustSent = 0;

        //             self.loadingModal = false;
        //             self.generateStatusCodeMessage(jqXHR,true,'past-due-notice-details');
        //         }
        //     });
        // },
        onSearchAL(search, loading) {
            var self = this;
            if (search.length > 3) {
                loading(true);
                if (self.findARGLMatch == true){
                    self.searchField(loading, search, 'jv_number_all', '');
                }else{
                    self.searchField(loading, search, 'jv_number', '');
                }
            }
        },
        removeFileFromServer: function(file,flag,key){

            var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {

                if(self.selId != '' && self.selId != undefined){
                    $.ajax({
                        url: process.env.ROOT_API + "/remove-deposit-file",
                        type: "POST",
                        crossDomain: true,
                        dataType: "json",
                        headers: this.ajxHeaders,
                        data: {
                            bank_rec_id:self.selId,
                            doc_path:file,
                            flag:flag
                        },
                        success: function(data) {
                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {
                                // self.filesArr.splice(key,1);
                                self.docArr.splice(key,1);
                                self.dropZonePreviewFiles.splice(key,1);
                                // $("#myModal").modal("hide");
                                // self.$refs.files.value = '';
                                // self.existFilesArr = [];
                                // if (self.valuesFound) {
                                //     self.valuesFound = false;
                                //     self.matchingValuesError = [];
                                // }
                            }
                        },
                        error: function(jqXHR, exception) {
                            self.$parent.loading = false;
                            self.filesArr.splice(key,1);
                            self.docArr.splice(key,1);
                            // self.validateDocs.splice(key,1);
                            self.generateStatusCodeMessage(jqXHR,true,'deposit-doc-remove');
                        }
                    });

                } else{

                    self.filesArr.splice(key,1);
                    self.$refs.files.value = '';

                }
            }

        },
        removeAllFiles() {
            var self = this;
            self.$refs.depositDropzone.removeAllFiles();
        },

        grossVoucher: function(invoiceId,currentOpenInvAmt,flag = '',from=''){
            var self = this;
            if (flag != '' && flag == 'multiple'){
                if (from == 'payment'){
                    invoiceId = self.apPaymentIds;
                }else{
                    invoiceId = self.voucherIds;
                }
                 if (self.voucherIds.length){
                    for(var i =0;i<self.voucherIds.length; i++){
                       
                    }
                }
            }else{
                if (currentOpenInvAmt > self.difference) {
                    self.$swal('','Open Amount cannot be greater than PMT Amount.','info');
                    return;
                }
            }
            self.showFullAndCustom = false;
            self.loadingModal = true;
            $('#fullAPMap').addClass('hide');
            // }else{
            $.ajax({
                url: process.env.ROOT_API + "/map-bank-voucher-receipt",
                type: "POST",
                headers: this.ajxHeaders,
                data:{
                    invoice_id:invoiceId,
                    receipt_item_id:self.selId,
                    flag:flag,
                    tr_type:self.transaction_type.value,
                    from:from
                },
                dataType: "json",
                success: function (data) {
                    self.loadingModal = false;
                    self.showFullAndCustom = false;
                    console.log(data);
                    $('#fullAPMap').removeClass('hide');
                    if (data.status == "success") {
                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                        }
                        self.trTypeDisable = true;
                        self.voucherIds = [];
                        self.apPaymentIds = [];
                        // self.amount_applied += data.content.application_amount;
                        if (flag == 'multiple' || self.partialAPMatch){
                            // $("#cancelCheckbox").prop('checked',false);
                            self.invoiceIds = [];
                            if (self.voucherrows && self.voucherrows.length){
                                for(var i=0;i<self.voucherrows.length;i++){
                                    $("#cancelCheckbox"+i).prop('checked',false);
                                }
                            }
                            if (self.paymentRows && self.paymentRows.length){
                                for(var i=0;i<self.paymentRows.length;i++){
                                    $("#cancelCheckbox"+i).prop('checked',false);
                                }
                            }
                            self.$refs['listPaymentTable'].unselectAllInternal();
                            self.mapperIdArr = [];

                            self.getVouchers(from);
                        }else{
                            self.settlement();
                        }

                        self.$swal('','Item successfully mapped','success');
                    }
                },
                error: function (jqXHR, exception) {
                    $('#fullAPMap').removeClass('hide');
                    self.loadingModal = false;
                    self.showFullAndCustom = false;
                    self.generateStatusCodeMessage(jqXHR,false,'gross-invoice-map-bank')
                }
            });
            // }

        },
        grossGLMapping:function(id,amount,flag){
            var self = this;

            if (amount > self.difference){
                self.$swal('','GL Amount is greater than payment amount','info');
                return;
            }
            self.loadingModal = true;
            // }else{
            $('#fullGlMap').addClass('hide');
            $.ajax({
                url: process.env.ROOT_API + "/map-gl-receipt",
                type: "POST",
                headers: this.ajxHeaders,
                data:{
                    gl_id:id,
                    receipt_item_id:self.selId,
                    flag:flag,
                    tr_type:self.transaction_type.value
                },
                dataType: "json",
                success: function (data) {
                    self.loadingModal = false;
                    // self.showFullAndCustom = true;
                    $('#fullGlMap').removeClass('hide');
                    if (data.status == "success") {
                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                        }
                        self.trTypeDisable = true;
                        if (data.content.id != undefined){
                            self.difference = data.content.balance.toFixed(2);
                            self.amount_applied = data.content.applied_amount;
                            self.payment_amount = data.content.amount;
                        }

                        self.fetchGLWithSameAmount('');
                        // self.loadReceiptItem();
                        // self.settlement();
                        self.$swal('','Item successfully mapped','success');
                    }
                },
                error: function (jqXHR, exception) {
                    $('#fullGlMap').removeClass('hide');
                    self.loadingModal = false;
                    self.generateStatusCodeMessage(jqXHR,false,'gross-gl-map-bank')
                }
            });
        },
        cancelAPTransaction:function(evt,id,flag){
            var self = this;

            self.loadingModal = true;
            // }else{
            $.ajax({
                url: process.env.ROOT_API + "/cancel-ap-transaction",
                type: "POST",
                headers: this.ajxHeaders,
                data:{
                    id:id,
                    receipt_item_id:self.selId,
                    flag:flag
                },
                dataType: "json",
                success: function (data) {
                    self.loadingModal = false;
                    // self.showFullAndCustom = true;
                    $('#fullMap').removeClass('hide');
                    if (data.status == "success") {
                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                        }

                        self.loadReceiptItem();
                    }
                },
                error: function (jqXHR, exception) {
                    $('#fullMap').removeClass('hide');
                    self.loadingModal = false;
                    self.generateStatusCodeMessage(jqXHR,false,'gross-gl-map-bank')
                }
            });
        },
        bankRecDelete:function(){
          var self = this;
          var data = self.$refs['listbankTransferTable'].selectedRows;
          var selectedRows = [];

          for (var i = 0; i < data.length; i++) {
              // console.log(data[i].tag); return;
              if (!data[i].tag.includes("Pending") && data[i].type != 'Adj'){
                  self.$swal('','Please select records with pending status only','info');
                  return;
              }
              selectedRows.push(self.$refs['listbankTransferTable'].selectedRows[i].id)
          }
          self.loading = true;
          $("#deleteBankRecBtn").val("Deleting ...");
          $.ajax({
                    url: process.env.ROOT_API + "/bank-transfer/delete",
                    type: "POST",
                    data: 'id=' + selectedRows,
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                      var msg = "";
                      if(data.content.length > 0){
                        msg = "#Sequence No : "+data.content+" was skipped in deletion";
                        self.$swal("",msg,'info');
                      }
                      EventBus.$emit('clear-all-flags', false);
                      self.loadList('load');
                      return;
                    },
                    error: function (jqXHR, exception) {
                      self.loading = false;
                      self.generateStatusCodeMessage(jqXHR,false,'bank-transferlist');
                    }
                });
        },
        changeDiscarded:function(flag){
            var self = this;

            var data = self.$refs['listbankTransferTable'].selectedRows;
            var selectedRows = [];
            var fl = '';
            if (flag == 'discard'){
                fl = 'yes';
            }else{
                fl = 'no';
            }
            for (var i = 0; i < data.length; i++) {
                // console.log(data[i].tag); return;
                if (!data[i].tag.includes("Pending") && fl == 'yes'){
                    self.$swal('','Please select records with pending status only','info');
                    return;
                }
                if (!data[i].tag.includes("Discarded") && fl == 'no'){
                    self.$swal('','Please select records with discarded status only','info');
                    return;
                }
                selectedRows.push(self.$refs['listbankTransferTable'].selectedRows[i].id)
            }
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/bank/discard-change",
                type: "POST",
                data: {id : selectedRows,flag:fl},
                headers: this.ajxHeaders,
                dataType: 'json',
                success: function (data) {
                    var msg = "";
                    if (flag == 'undo'){
                        msg = "Records status changed successfully";

                    }else{
                        msg = "Records discarded successfully";

                    }
                    self.$swal("",msg,'info');
                    EventBus.$emit('clear-all-flags', false);
                    self.loadList('load');
                    return;
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'bank-transferlist');
                }
            });

        },

        onChangeTrType:function(){
            var self = this;

            if (self.transaction_type != null && self.transaction_type.value && self.transaction_type.value == 'ar'){
                self.depositRecords = true;
            }
            if (self.transaction_type != null && self.transaction_type.value && self.transaction_type.value == 'ap'){
                self.depositRecords = false;
            }
        }
    }
}
</script>
<style scoped>
.additionClassTop{
    top: -230px !important;
}
.mapReceiptModal .wo-vendorinv-panel{
    position: relative;
    right:0;
    top: -10px;
    box-shadow: 0 50px 100px rgba(50, 50, 93, .1), 0 15px 35px rgba(50, 50, 93, .15), 0 5px 15px rgba(0, 0, 0, .1);
    background-color: #fff;
    padding: 15px;
    width: 90%;
    padding-bottom: 100px;
    border-radius: 5px;
    z-index: 5000;
}
.mapReceiptModal .wo-vendorinv-form{
    position: relative;
}
.mapReceiptModal .wo-vendorinv-form .form-title{
    font-size: 22px;
    margin-bottom: 10px;
    background: rgba(242, 245, 245, 1);
    padding: 5px 10px;
}
.adjustWidth{
    width: 200% !important;
    margin-left: -300px;
}
</style>



// WEBPACK FOOTER //
// src/components/accounting/BankTransferList.vue